import React, { useState, useEffect, useMemo, useRef } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import avatar1 from "../../../../src/assets/images/placeholder.jpg";
import maleImg from "../../../../src/assets/images/avatar/male2.png";
import femaleImg from "../../../../src/assets/images/avatar/female.png";
import { Tooltip } from "react-tooltip";
import { Modal, Button, Row, Col, Alert } from "react-bootstrap";
import countryStateCity from "../AppsMenu/Patients/countriesStatesCities.json";
import { getBranchesAction } from "../../../store/actions/BranchAction.js";
import {
  getPrescriptions,
  updateDeliveryStatus,
  addDeliveryAddress,
  downloadPrescription,
  prescriptionFirstAssigned
} from "../../../store/actions/medicalActions.js";
import Loader from "../../components/Common/Loader";
import icon from "../../../assets/images/icons8-call-102.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  handleSuccess,
  showErrorAlert,
} from "../../../services/ErrorHandlingService.js";
import { fetchMedicalDashboardAction } from "../../../store/actions/DashboardCardAction.js";
import { formatDate } from "../../../utils/dateUtils.js";
import { formatName } from "../../../utils/formatName.js";
const Medical = () => {
  const dispatch = useDispatch();
  const prescriptionRef = useRef(null);
  const branches = useSelector((state) => state.branches?.branches || [])
  const {
    loading,
    updateLoading,
    addressLoading,
    error,
    updateError,
    addressError,
    selectedPrescription,
  } = useSelector((state) => state.medical);

  const { prescriptions } = useSelector((state) => {
    console.log("state in useSelector:", state);
    return state.medical;
  });
  const dashboardData = useSelector((state) => {
    console.log("Dashboard Data:", state.dashboard.medicalDashboard);
    return state?.dashboard?.medicalDashboard || {};
  });
  // Local state
  const [isDownloading, setIsDownloading] = useState(false);

  const [selectedMedicines, setSelectedMedicines] = useState({});

  const [selectedAddressId, setSelectedAddressId] = useState(null);

  const [showAddressModal, setShowAddressModal] = useState(false);

  const [formData, setFormData] = useState({ deliveryOption: "" });

  const [statusFilter, setStatusFilter] = useState({
    value: "PENDING",
    label: "Pending",
  });
  const [addressData, setAddressData] = useState({
    phoneNumber: "",
    addressLine1: "",
    addressLine2: "",
    area: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
  });

  const [deliveryData, setDeliveryData] = useState({
    delivery_partner: "",
    delivery_code: "",
    delivery_date: "",
    delivery_status: "PENDING",
    delivery_id: "",
  });

  const [showStatusModal, setShowStatusModal] = useState(false);

  const [selectedDelivery, setSelectedDelivery] = useState(null);

  const [newStatus, setNewStatus] = useState("");

  const [deliveryDetails, setDeliveryDetails] = useState({
    delivery_partner: "",
    delivery_code: "",
    delivery_date: "",
    delivery_id: "",
  });

  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);

  const [countries, setCountries] = useState([]);

  const [states, setStates] = useState([]);

  const [cities, setCities] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  // const branches = useSelector((state) => state.branches.branches);

  const [selectedBranch, setSelectedBranch] = useState("");
  const [modeFilter, setModeFilter] = useState("");
  const [deliveryOptionFilter, setDeliveryOptionFilter] = useState("");
  const [deliveryStatusFilter, setDeliveryStatusFilter] = useState("");

  const getDurationLabel = (value) => {
    const val = parseFloat(value);

    const month = Math.floor(val);
    const fraction = val - month;

    const days =
      fraction === 0.25 ? 7 :
        fraction === 0.5 ? 15 :
          fraction === 0.75 ? 22 : 0;

    if (month === 0) return `${days} Days`;
    if (days === 0) return `${month} Month${month > 1 ? "s" : ""}`;

    return `${month} Month${month > 1 ? "s" : ""} ${days} Days`;
  };

  useEffect(() => {
    dispatch(getBranchesAction());
    dispatch(getPrescriptions(statusFilter.value));
    dispatch(fetchMedicalDashboardAction());
  }, [dispatch, statusFilter.value]);

  const patientsPrescriptions = dashboardData.patientsPrescriptions || 0;

  useEffect(() => {
    const countryList = countryStateCity.map((country) => ({
      value: country.name,
      label: country.name,
    }));
    setCountries(countryList);
  }, []);

  useEffect(() => {
    if (addressData.country) {
      const selectedCountry = countryStateCity.find(
        (c) => c.name === addressData.country
      );
      setStates(
        selectedCountry?.states?.map((state) => ({
          value: state.name,
          label: state.name,
        })) || []
      );
    } else {
      setStates([]);
    }
  }, [addressData.country]);

  const branchId = selectedPrescription?.patient_details?.branch;

  const branchName = branches.find(
    (b) => Number(b.branch_id) === Number(branchId)
  )?.branch_name || "N/A";


  // Load cities based on selected state
  useEffect(() => {
    if (addressData.country && addressData.state) {
      const selectedCountry = countryStateCity.find(
        (c) => c.name === addressData.country
      );
      const selectedState = selectedCountry?.states?.find(
        (s) => s.name === addressData.state
      );
      setCities(
        selectedState?.cities?.map((city) => ({
          value: city.name,
          label: city.name,
        })) || []
      );
    } else {
      setCities([]);
    }
  }, [addressData.country, addressData.state]);

  const handleViewPatient = async (prescriptionId) => {
    const result = await dispatch(
      prescriptionFirstAssigned(prescriptionId)
    );

    if (result.success) {
      console.log("✅ API called successfully");
    } else {
      console.log("❌ API failed");
    }
  };
  // Update useEffect to select first patient by default only when no prescription is selected
  // useEffect(() => {
  //   if (prescriptions && prescriptions.length > 0) {
  //     if (!selectedPrescription) {
  //       // Auto-select only if nothing selected
  //     const firstPatient = {
  //       id: prescriptions[0].patient_details.patient_id,
  //       name:
  //         prescriptions[0].patient_details.first_name +
  //         " " +
  //         prescriptions[0].patient_details.last_name,
  //       avatar:
  //         prescriptions[0].patient_details.patient_photo ||
  //         (prescriptions[0].patient_details.gender === "Female"
  //           ? femaleImg
  //           : maleImg),
  //       disease: prescriptions[0].patient_details.reason || "General Checkup",
  //       doctor: prescriptions[0].patient_details.assigned_doctor || "-",
  //       time: prescriptions[0].patient_details.time_slot || "-",
  //       prescribeDate: prescriptions[0].created_at || "-",
  //       status: prescriptions[0].status || "Pending",
  //       prescribeBy: prescriptions[0].prescribed_by || "N/A",
  //       prescriptions: prescriptions[0],
  //     };

  //     handlePatientSelect(firstPatient); // will auto-scroll smoothly
  //   } else {
  //     const updated = prescriptions.find(
  //       (p) => p.prescription_id === selectedPrescription?.prescription_id
  //     );
  //     if (updated) {
  //       dispatch({
  //         type: "SET_SELECTED_PRESCRIPTION",
  //         payload: updated,
  //       });
  //     }
  //   }
  //   }
  // }, [prescriptions, statusFilter.value]);
  const [firstLoad, setFirstLoad] = useState(true);

  useEffect(() => {
    if (!prescriptions || prescriptions.length === 0) return;

    // ✅ On first load, auto-select first patient only once
    if (firstLoad && !selectedPrescription) {
      const firstPatient = {
        id: prescriptions[0].patient_details.patient_id,
        name: formatName(
          prescriptions[0].patient_details.first_name +
          " " +
          prescriptions[0].patient_details.last_name),
        avatar:
          prescriptions[0].patient_details.patient_photo ||
          (prescriptions[0].patient_details.gender === "Female"
            ? femaleImg
            : maleImg),
        disease: prescriptions[0].patient_details.reason || "General Checkup",
        doctor: prescriptions[0].patient_details.assigned_doctor || "-",
        time: prescriptions[0].patient_details.time_slot || "-",
        prescribeDate: prescriptions[0].created_at || "-",
        status: prescriptions[0].status || "Pending",
        prescribeBy: prescriptions[0].prescribed_by || "N/A",
        prescriptions: prescriptions[0],
      };

      handlePatientSelect(firstPatient);
      setFirstLoad(false); // ✅ Prevent future auto-selects
      return;
    }

    // ✅ After initial load: keep selected prescription in sync if data changes
    if (!firstLoad && selectedPrescription) {
      const updated = prescriptions.find(
        (p) => p.prescription_id === selectedPrescription?.prescription_id
      );
      if (updated) {
        dispatch({
          type: "SET_SELECTED_PRESCRIPTION",
          payload: updated,
        });
      } else {
        // ❗ If the current prescription no longer exists under this filter (e.g. delivered → pending)
        dispatch({ type: "SET_SELECTED_PRESCRIPTION", payload: null });
        setSelectedMedicines({});
        setSelectedAddressId(null);
        setFormData({ deliveryOption: "" });
        setDeliveryData({
          delivery_partner: "",
          delivery_code: "",
          delivery_date: "",
          delivery_status: "PENDING",
          delivery_id: "",
        });
      }
    }
  }, [prescriptions, statusFilter.value, selectedPrescription, firstLoad, dispatch]);

  useEffect(() => {
    if (!prescriptions) return;

    if (prescriptions.length > 0 && selectedPrescription) {
      const updated = prescriptions.find((p) => {
        const currentId = selectedPrescription?.prescription_id;
        if (p.prescription_id !== currentId) return false;


        const meds = p.medicines || [];
        const allDelivered = meds.length > 0 && meds.every(m => m.delivery_status === "DELIVERED");

        if (statusFilter.value === "PENDING" && !allDelivered) return true;
        if (statusFilter.value === "DELIVERED" && allDelivered) return true;
        if (statusFilter.value === "ALL") return true;

        return false;
      });

      if (updated) {
        dispatch({
          type: "SET_SELECTED_PRESCRIPTION",
          payload: updated,
        });
      } else {

        dispatch({ type: "SET_SELECTED_PRESCRIPTION", payload: null });
        setSelectedMedicines({});
        setSelectedAddressId(null);
        setFormData({ deliveryOption: "" });
        setDeliveryData({
          delivery_partner: "",
          delivery_code: "",
          delivery_date: "",
          delivery_status: "PENDING",
          delivery_id: "",
        });
      }
    }

    if (prescriptions.length === 0 && selectedPrescription) {
      // Clear if no prescriptions left at all
      dispatch({ type: "SET_SELECTED_PRESCRIPTION", payload: null });
      setSelectedMedicines({});
      setSelectedAddressId(null);
      setFormData({ deliveryOption: "" });
      setDeliveryData({
        delivery_partner: "",
        delivery_code: "",
        delivery_date: "",
        delivery_status: "PENDING",
        delivery_id: "",
      });
    }
  }, [prescriptions, selectedPrescription, statusFilter.value, dispatch]);

  const handleDeliveryOptionChange = (selectedOption) => {
    setFormData({ ...formData, deliveryOption: selectedOption.value });
  };

  const handleStatusFilterChange = (selectedOption) => {
    setStatusFilter(selectedOption);
  };

  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    setAddressData({ ...addressData, [name]: value });
  };

  // const handleDownload = () => {
  //   window.open(
  //     "https://www.aeee.in/wp-content/uploads/2020/08/Sample-pdf.pdf",
  //     "_blank"
  //   );
  // };
  const handleDownload = async () => {
    const prescription_id = selectedPrescription?.prescription_id;
    const patient_id = selectedPrescription?.patient_details?.patient_id;

    if (prescription_id && patient_id) {
      try {
        setIsDownloading(true);         // Start Loader
        await dispatch(downloadPrescription(patient_id, prescription_id));
      } catch (error) {
        console.error("Download failed", error);
      } finally {
        setIsDownloading(false);        // Stop Loader
      }
    } else {
      showErrorAlert("Patient or Prescription ID is missing.");
    }
  };


  const handleDeliveryDataChange = (e) => {
    const { name, value } = e.target;
    setDeliveryData({ ...deliveryData, [name]: value });
  };

  const handleMedicineSelect = (medicine, isSelected) => {
    setSelectedMedicines((prev) => ({
      ...prev,
      [medicine.medicine_id]: isSelected ? { ...medicine } : undefined,
    }));
  };

  useEffect(() => {
    // Set loading state
    setIsFilterLoading(true);

    // Clear selected prescription first when filter changes
    dispatch({
      type: "SET_SELECTED_PRESCRIPTION",
      payload: null,
    });
    setSelectedMedicines({});
    setSelectedAddressId(null);
    setFormData({ deliveryOption: "" });
    setDeliveryData({
      delivery_partner: "",
      delivery_code: "",
      delivery_date: "",
      delivery_status: "PENDING",
      delivery_id: "",
    });

    // Then fetch new data
    dispatch(getPrescriptions(statusFilter.value)).finally(() => {
      setIsFilterLoading(false);
    });
  }, [dispatch, statusFilter.value]);

  // Clear selected prescription when filtered results are empty
  useEffect(() => {
    if (prescriptions && prescriptions.length === 0) {
      dispatch({
        type: "SET_SELECTED_PRESCRIPTION",
        payload: null,
      });
      setSelectedMedicines({});
      setSelectedAddressId(null);
      setFormData({ deliveryOption: "" });
      setDeliveryData({
        delivery_partner: "",
        delivery_code: "",
        delivery_date: "",
        delivery_status: "PENDING",
        delivery_id: "",
      });
    }
  }, [prescriptions, dispatch]);

  const disableActions = selectedPrescription?.is_valid === "No";
  const statusOptions = [
    { value: "PENDING", label: "Pending" },
    { value: "DISPATCHED", label: "Dispatched" },
    { value: "DELIVERED", label: "Delivered" },
  ];
  const getValidPhotoUrl = (photoUrl) => {
    if (!photoUrl) return defaultAvatar;

    // If multiple "https://" exist, keep only the last valid part
    if ((photoUrl.match(/https:\/\//g) || []).length > 1) {
      const parts = photoUrl.split("https://");
      return "https://" + parts[parts.length - 1];
    }

    return photoUrl;
  };
  const todayPatients = useMemo(() => {
    // Use prescriptions in the original order from API response
    return (prescriptions || []).map((object) => ({
      id: object.patient_details.patient_id,
      name: formatName(
        object.patient_details.first_name +
        " " +
        object.patient_details.last_name),
      // avatar:
      //   object.patient_details.patient_photo ||
      //   (object.patient_details.gender === "Female"
      //     ? femaleImg
      //     : maleImg),
      avatar: object.patient_details.patient_photo
        ? getValidPhotoUrl(object.patient_details.patient_photo)
        : object.patient_details.gender === "Female"
          ? femaleImg
          : maleImg,

      disease: object.patient_details.reason || "General Checkup",
      doctor: object.patient_details.assigned_doctor || "-",
      time: object.patient_details.time_slot || "-",
      prescribeDate: object.created_at || "-",
      status: object.status || "Pending",
      prescribeBy: object.prescribed_by || "N/A",
      prescriptions: object || [],
    }));
  }, [prescriptions]);
  const filteredPatients = useMemo(() => {
    return todayPatients.filter((p) => {
      const matchesBranch =
        !selectedBranch?.value ||
        p.prescriptions.patient_details.branch == selectedBranch.value;

      const matchesMode =
        !modeFilter?.value ||
        p.prescriptions.patient_details.visit_type == modeFilter.value;

      const matchesDeliveryOption =
        !deliveryOptionFilter?.value ||
        p.prescriptions.delivery_details?.some(
          (d) => d.delivery_option == deliveryOptionFilter.value
        );

      const matchesDeliveryStatus =
        !deliveryStatusFilter?.value ||
        p.prescriptions.delivery_details?.some(
          (d) => d.delivery_status == deliveryStatusFilter.value
        ) ||
        p.prescriptions.medicines?.some(
          (m) => m.delivery_status == deliveryStatusFilter.value
        );

      return (
        matchesBranch &&
        matchesMode &&
        matchesDeliveryOption &&
        matchesDeliveryStatus
      );
    });
  }, [
    todayPatients,
    selectedBranch,
    modeFilter,
    deliveryOptionFilter,
    deliveryStatusFilter,
  ]);


  // Add loading state for filter changes
  const [selectedMedicineId, setSelectedMedicineId] = useState(null);
  const [isFilterLoading, setIsFilterLoading] = useState(false);

  const handlePatientSelect = async (object) => {
    try {
      dispatch({
        type: "SET_SELECTED_PRESCRIPTION",
        payload: object.prescriptions,
      });

      if (prescriptionRef.current) {
        prescriptionRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }

      // Initialize selectedMedicines based on delivery_details
      // const initialSelectedMedicines = {};
      // if (object.prescriptions?.delivery_details) {
      //   object.prescriptions.delivery_details.forEach((detail) => {
      //     if (detail.delivery_medicines) {
      //       detail.delivery_medicines.forEach((medicine) => {
      //         initialSelectedMedicines[medicine.medicine_id] = medicine;
      //       });
      //     }
      //   });
      // }
      // setSelectedMedicines(initialSelectedMedicines);// inside handlePatientSelect(...) — replace the existing initialSelectedMedicines creation
      const initialSelectedMedicines = {};
      if (object.prescriptions?.delivery_details) {
        object.prescriptions.delivery_details.forEach((detail) => {
          // Only import PENDING deliveries here so they show as visually checked
          if (detail.delivery_status === "PENDING") {
            detail.delivery_medicines?.forEach((medicine) => {
              initialSelectedMedicines[medicine.medicine_id] = {
                ...medicine,
                delivery_status: "PENDING",    // visible as checked initially
              };
            });
          }
          // NOTE: we intentionally skip delivery_status === "DELIVERED"
        });
      }
      setSelectedMedicines(initialSelectedMedicines);



      setSelectedAddressId(null);
      setDeliveryData({
        delivery_partner: "",
        delivery_code: "",
        delivery_date: "",
        delivery_status: "PENDING",
      });
    } catch (error) {
      console.error("Error selecting patient:", error);
      showErrorAlert("Failed to select patient");
    }
  };

  const areAllMedicinesDelivered = useMemo(() => {
    if (!selectedPrescription?.medicines) return false;
    return selectedPrescription.medicines.every(
      (medicine) =>
        medicine.delivery_status === "DELIVERED" ||
        selectedMedicines[medicine.medicine_id]?.delivery_status === "DELIVERED"
    );
  }, [selectedPrescription?.medicines, selectedMedicines]);



  const handleMarkAsDelivered = async () => {
    try {
      // const deliveryMedicines = Object.values(selectedMedicines)
      // .filter(
      //   (medicine) =>
      //     medicine && medicine.delivery_status !== "DELIVERED" // exclude already delivered
      // )
      // .map((medicine) => medicine.prescription_medicine_id);
      const deliveryMedicines = Object.values(selectedMedicines)
        .filter((m) => m && m.delivery_status === "CONFIRM") // ✅ only confirmed medicines
        .map((m) => m.prescription_medicine_id);


      // Create local delivery record
      const localDeliveryRecord = {
        delivery_date: new Date().toLocaleString(),
        delivery_status: "DELIVERED",
        delivery_option: "BY_HAND",
        delivery_medicines: Object.values(selectedMedicines)
          .filter((medicine) => medicine)
          .map((medicine) => ({
            ...medicine,
            delivery_status: "DELIVERED",
            quantity_delivered: medicine.updated_qty,
          })),
      };

      // Update local state through Redux before API call
      dispatch({
        type: "ADD_DELIVERY_DETAIL",
        payload: {
          prescription_id: selectedPrescription?.prescription_id,
          delivery_detail: localDeliveryRecord,
        },
      });

      const payload = {
        patient_id: selectedPrescription?.patient_details?.patient_id,
        prescription_id: selectedPrescription?.prescription_id,
        delivery_medicines: deliveryMedicines.join("|"),
        delivery_option: "BY_HAND",
        delivery_details: JSON.stringify({ delivery_status: "DELIVERED" }),
      };

      // const result = await dispatch(updateDeliveryStatus(payload));

      // if (result.success) {
      //   // Reset delivery option
      //   setFormData({ deliveryOption: "" });
      //   dispatch(getPrescriptions(statusFilter.value));
      //   dispatch(fetchMedicalDashboardAction());
      //   const updatedSelectedMedicines = { ...selectedMedicines };
      //   Object.values(selectedMedicines)
      //     .filter((medicine) => medicine)
      //     .forEach((medicine) => {
      //       updatedSelectedMedicines[medicine.medicine_id] = {
      //         ...medicine,
      //         delivery_status: "DELIVERED",
      //       };
      //     });
      //   setSelectedMedicines(updatedSelectedMedicines);

      //   handleSuccess("Delivery marked as completed successfully!");
      //   return;
      // }
      const result = await dispatch(updateDeliveryStatus(payload));

      if (result.success) {
        // Reset delivery option
        setFormData({ deliveryOption: "" });

        // 👇 use ALL if fully delivered, otherwise stay with current filter BEFORE
        // const refreshFilter =
        //   payload.delivery_status === "DELIVERED" ? "ALL" : statusFilter.value;
        // after 
        const refreshFilter =
          newStatus === "DELIVERED" || deliveryData.delivery_status === "DELIVERED"
            ? "ALL"
            : statusFilter.value;

        dispatch(getPrescriptions(refreshFilter));
        dispatch(fetchMedicalDashboardAction());

        const updatedSelectedMedicines = { ...selectedMedicines };
        Object.values(selectedMedicines)
          .filter((medicine) => medicine)
          .forEach((medicine) => {
            updatedSelectedMedicines[medicine.medicine_id] = {
              ...medicine,
              delivery_status: "DELIVERED",
            };
          });
        setSelectedMedicines(updatedSelectedMedicines);

        handleSuccess("Delivery marked as completed successfully!");
        return;
      }

    } catch (error) {
      console.error("Error updating delivery status:", error);
      showErrorAlert(
        error.message || "An error occurred while updating delivery status"
      );
    }
  };


  // const handleCourierDone = async () => {
  //   try {
  //     if (!selectedAddressId) {
  //       showErrorAlert("Please select an address");
  //       return;
  //     }

  //     const deliveryMedicines = Object.values(selectedMedicines)
  //       .filter(
  //         (medicine) => medicine && medicine.delivery_status === "CONFIRM" // ✅ only confirmed medicines
  //       )
  //       .map((medicine) => medicine.prescription_medicine_id);

  //     if (deliveryMedicines.length === 0) {
  //       showErrorAlert("Please select at least one medicine for delivery");
  //       return;
  //     }

  //     if (
  //       deliveryData.delivery_status === "DISPATCHED" &&
  //       (!deliveryData.delivery_partner || !deliveryData.delivery_code)
  //     ) {
  //       showErrorAlert(
  //         "Please provide delivery partner and code for dispatched status"
  //       );
  //       return;
  //     }

  //     if (
  //       deliveryData.delivery_status === "DELIVERED" &&
  //       (!deliveryData.delivery_partner ||
  //         !deliveryData.delivery_code ||
  //         !deliveryData.delivery_date)
  //     ) {
  //       showErrorAlert(
  //         "Please provide delivery partner, code, and date for delivered status"
  //       );
  //       return;
  //     }

  //     const localDeliveryRecord = {
  //       delivery_date:
  //         deliveryData.delivery_date || new Date().toLocaleString(),
  //       delivery_status: deliveryData.delivery_status,
  //       delivery_option: "BY_COURIER",
  //       delivery_partner: deliveryData.delivery_partner,
  //       delivery_code: deliveryData.delivery_code,
  //       delivery_address_id: selectedAddressId,
  //       delivery_medicines: Object.values(selectedMedicines)
  //         .filter((medicine) => medicine)
  //         .map((medicine) => ({
  //           ...medicine,
  //           delivery_status: deliveryData.delivery_status,
  //           quantity_delivered: medicine.quantity || medicine.updated_qty,
  //         })),
  //     };

  //     dispatch({
  //       type: "ADD_DELIVERY_DETAIL",
  //       payload: {
  //         prescription_id: selectedPrescription?.prescription_id,
  //         delivery_detail: localDeliveryRecord,
  //       },
  //     });

  //     const payload = {
  //       patient_id: selectedPrescription?.patient_details?.patient_id,
  //       prescription_id: selectedPrescription?.prescription_id,
  //       delivery_medicines: deliveryMedicines.join("|"),
  //       delivery_option: "BY_COURIER",
  //       delivery_status: deliveryData.delivery_status,
  //       delivery_address_id: selectedAddressId,
  //       delivery_partner: deliveryData.delivery_partner || "",
  //       delivery_code: deliveryData.delivery_code || "",
  //       delivery_date: deliveryData.delivery_date || "",
  //       delivery_id: deliveryData.delivery_id || "",
  //     };

  //     const result = await dispatch(updateDeliveryStatus(payload));

  //     if (result.success) {
  //       setFormData({ deliveryOption: "" });
  //       setDeliveryData({
  //         delivery_partner: "",
  //         delivery_code: "",
  //         delivery_date: "",
  //         delivery_status: "PENDING",
  //         delivery_id: "",
  //       });
  //       setSelectedAddressId(null);

  //       const updatedSelectedMedicines = { ...selectedMedicines };
  //       Object.values(selectedMedicines)
  //         .filter((medicine) => medicine)
  //         .forEach((medicine) => {
  //           updatedSelectedMedicines[medicine.medicine_id] = {
  //             ...medicine,
  //             delivery_status: deliveryData.delivery_status,
  //           };
  //         });
  //       setSelectedMedicines(updatedSelectedMedicines);

  //       handleSuccess(
  //         result.message || "Delivery status updated successfully!"
  //       );
  //       dispatch(getPrescriptions(statusFilter.value));
  //       dispatch(fetchMedicalDashboardAction());
  //       return;
  //     } else {
  //       showErrorAlert(result.message || "Failed to update delivery status");
  //     }
  //   } catch (error) {
  //     console.error("Error updating courier delivery:", error);
  //     showErrorAlert(
  //       error.message || "An error occurred while updating delivery status"
  //     );
  //   }
  // };
  //   const handleCourierDone = async () => {
  //     try {
  //       if (!selectedAddressId) {
  //         showErrorAlert("Please select an address");
  //         return;
  //       }

  //       // ✅ Only confirmed medicines are considered
  //       const deliveryMedicines = Object.values(selectedMedicines)
  //         .filter((medicine) => medicine && medicine.delivery_status === "CONFIRM")
  //         .map((medicine) => medicine.prescription_medicine_id);

  //       if (deliveryMedicines.length === 0) {
  //         showErrorAlert("Please select at least one medicine for delivery");
  //         return;
  //       }

  //       if (
  //         deliveryData.delivery_status === "DISPATCHED" &&
  //         (!deliveryData.delivery_partner || !deliveryData.delivery_code)
  //       ) {
  //         showErrorAlert(
  //           "Please provide delivery partner and code for dispatched status"
  //         );
  //         return;
  //       }

  //       if (
  //         deliveryData.delivery_status === "DELIVERED" &&
  //         (!deliveryData.delivery_partner ||
  //           !deliveryData.delivery_code ||
  //           !deliveryData.delivery_date)
  //       ) {
  //         showErrorAlert(
  //           "Please provide delivery partner, code, and date for delivered status"
  //         );
  //         return;
  //       }

  //       // ✅ Local delivery record also uses only confirmed medicines
  //       const localDeliveryRecord = {
  //         delivery_date: deliveryData.delivery_date || new Date().toLocaleString(),
  //         delivery_status: deliveryData.delivery_status,
  //         delivery_option: "BY_COURIER",
  //         delivery_partner: deliveryData.delivery_partner,
  //         delivery_code: deliveryData.delivery_code,
  //         delivery_address_id: selectedAddressId,
  //         delivery_medicines: Object.values(selectedMedicines)
  //           .filter(
  //             (medicine) => medicine && medicine.delivery_status === "CONFIRM"
  //           )
  //           .map((medicine) => ({
  //             ...medicine,
  //             delivery_status: deliveryData.delivery_status,
  //             quantity_delivered: medicine.quantity || medicine.updated_qty,
  //           })),
  //       };

  //       dispatch({
  //         type: "ADD_DELIVERY_DETAIL",
  //         payload: {
  //           prescription_id: selectedPrescription?.prescription_id,
  //           delivery_detail: localDeliveryRecord,
  //         },
  //       });

  //       const payload = {
  //         patient_id: selectedPrescription?.patient_details?.patient_id,
  //         prescription_id: selectedPrescription?.prescription_id,
  //         delivery_medicines: deliveryMedicines.join("|"), // ✅ only confirmed
  //         delivery_option: "BY_COURIER",
  //         delivery_status: deliveryData.delivery_status,
  //         delivery_address_id: selectedAddressId,
  //         delivery_partner: deliveryData.delivery_partner || "",
  //         delivery_code: deliveryData.delivery_code || "",
  //         delivery_date: deliveryData.delivery_date || "",
  //         delivery_id: deliveryData.delivery_id || "",
  //       };

  // //       const result = await dispatch(updateDeliveryStatus(payload));

  // //       if (result.success) {
  // //         setFormData({ deliveryOption: "" });
  // //         setDeliveryData({
  // //           delivery_partner: "",
  // //           delivery_code: "",
  // //           delivery_date: "",
  // //           delivery_status: "PENDING",
  // //           delivery_id: "",
  // //         });
  // //         setSelectedAddressId(null);

  // //         const updatedSelectedMedicines = { ...selectedMedicines };
  // //         Object.values(selectedMedicines)
  // //           .filter((medicine) => medicine && medicine.delivery_status === "CONFIRM")
  // //           .forEach((medicine) => {
  // //             updatedSelectedMedicines[medicine.medicine_id] = {
  // //               ...medicine,
  // //               delivery_status: deliveryData.delivery_status,
  // //             };
  // //           });
  // //         setSelectedMedicines(updatedSelectedMedicines);

  // //         // handleSuccess(result.message || "Delivery status updated successfully!");
  // //         // dispatch(getPrescriptions(statusFilter.value));
  // //         // dispatch(fetchMedicalDashboardAction());
  // //         handleSuccess(result.message || "Delivery status updated successfully!");

  // // // 👇 if this update made prescription fully delivered, reload ALL
  // // const refreshFilter =
  // //   deliveryData.delivery_status === "DELIVERED" ? "ALL" : statusFilter.value;

  // // dispatch(getPrescriptions(refreshFilter));
  // // dispatch(fetchMedicalDashboardAction());

  // //         return;
  // //       } 
  // const result = await dispatch(updateDeliveryStatus(payload));

  // if (result.success) {
  //   setFormData({ deliveryOption: "" });
  //   setDeliveryData({
  //     delivery_partner: "",
  //     delivery_code: "",
  //     delivery_date: "",
  //     delivery_status: "PENDING",
  //     delivery_id: "",
  //   });
  //   setSelectedAddressId(null);

  //   const updatedSelectedMedicines = { ...selectedMedicines };
  //   Object.values(selectedMedicines)
  //     .filter((medicine) => medicine && medicine.delivery_status === "CONFIRM")
  //     .forEach((medicine) => {
  //       updatedSelectedMedicines[medicine.medicine_id] = {
  //         ...medicine,
  //         delivery_status: payload.delivery_status, // 👈 use payload
  //       };
  //     });
  //   setSelectedMedicines(updatedSelectedMedicines);

  //   handleSuccess(result.message || "Delivery status updated successfully!");

  //   // 👇 use payload.delivery_status instead of deliveryData BEFORE
  //   // const refreshFilter =
  //   //   payload.delivery_status === "DELIVERED" ? "ALL" : statusFilter.value;
  //   const refreshFilter =
  //   newStatus === "DELIVERED" || deliveryData.delivery_status === "DELIVERED"
  //     ? "ALL"
  //     : statusFilter.value;

  //   dispatch(getPrescriptions(refreshFilter));
  //   dispatch(fetchMedicalDashboardAction());
  //   return;
  // }  else {
  //         showErrorAlert(result.message || "Failed to update delivery status");
  //       }
  //     } catch (error) {
  //       console.error("Error updating courier delivery:", error);
  //       showErrorAlert(
  //         error.message || "An error occurred while updating delivery status"
  //       );
  //     }
  //   };

  const handleCourierDone = async () => {
    try {
      if (!selectedAddressId) {
        showErrorAlert("Please select an address");
        return;
      }

      const deliveryMedicines = Object.values(selectedMedicines)
        .filter((m) => m && m.delivery_status === "CONFIRM")
        .map((m) => m.prescription_medicine_id);

      if (deliveryMedicines.length === 0) {
        showErrorAlert("Please select at least one medicine for delivery");
        return;
      }

      if (
        deliveryData.delivery_status === "DISPATCHED" &&
        (!deliveryData.delivery_partner || !deliveryData.delivery_code)
      ) {
        showErrorAlert("Please provide delivery partner and code for dispatched status");
        return;
      }

      if (
        deliveryData.delivery_status === "DELIVERED" &&
        (!deliveryData.delivery_partner ||
          !deliveryData.delivery_code ||
          !deliveryData.delivery_date)
      ) {
        showErrorAlert("Please provide delivery partner, code, and date for delivered status");
        return;
      }

      const localDeliveryRecord = {
        delivery_date: deliveryData.delivery_date || new Date().toLocaleString(),
        delivery_status: deliveryData.delivery_status,
        delivery_option: "BY_COURIER",
        delivery_partner: deliveryData.delivery_partner,
        delivery_code: deliveryData.delivery_code,
        delivery_address_id: selectedAddressId,
        delivery_medicines: Object.values(selectedMedicines)
          .filter((m) => m && m.delivery_status === "CONFIRM")
          .map((m) => ({
            ...m,
            delivery_status: deliveryData.delivery_status,
            quantity_delivered: m.quantity || m.updated_qty,
          })),
      };

      dispatch({
        type: "ADD_DELIVERY_DETAIL",
        payload: {
          prescription_id: selectedPrescription?.prescription_id,
          delivery_detail: localDeliveryRecord,
        },
      });

      const payload = {
        patient_id: selectedPrescription?.patient_details?.patient_id,
        prescription_id: selectedPrescription?.prescription_id,
        delivery_medicines: deliveryMedicines.join("|"),
        delivery_option: "BY_COURIER",
        delivery_status: deliveryData.delivery_status,
        delivery_address_id: selectedAddressId,
        delivery_partner: deliveryData.delivery_partner || "",
        delivery_code: deliveryData.delivery_code || "",
        delivery_date: deliveryData.delivery_date || "",
        delivery_id: deliveryData.delivery_id || "",
      };

      const result = await dispatch(updateDeliveryStatus(payload));

      if (result.success) {
        setFormData({ deliveryOption: "" });
        setDeliveryData({
          delivery_partner: "",
          delivery_code: "",
          delivery_date: "",
          delivery_status: "PENDING",
          delivery_id: "",
        });
        setSelectedAddressId(null);

        const updatedSelectedMedicines = { ...selectedMedicines };
        Object.values(selectedMedicines)
          .filter((m) => m && m.delivery_status === "CONFIRM")
          .forEach((m) => {
            updatedSelectedMedicines[m.medicine_id] = {
              ...m,
              delivery_status: payload.delivery_status,
            };
          });
        setSelectedMedicines(updatedSelectedMedicines);

        handleSuccess(result.message || "Delivery status updated successfully!");

        // ✅ Refresh and clear
        const allDelivered = Object.values(updatedSelectedMedicines).every(
          (m) => m.delivery_status === "DELIVERED"
        );
        const refreshFilter = allDelivered ? "PENDING" : statusFilter.value;

        if (allDelivered) {
          setStatusFilter({ value: "PENDING", label: "Pending" });
          dispatch({ type: "SET_SELECTED_PRESCRIPTION", payload: null });
          setSelectedMedicines({});
        }

        dispatch(getPrescriptions(refreshFilter));
        dispatch(fetchMedicalDashboardAction());
      } else {
        showErrorAlert(result.message || "Failed to update delivery status");
      }
    } catch (error) {
      console.error("Error updating courier delivery:", error);
      showErrorAlert("An error occurred while updating courier delivery");
    }
  };
  const handleAddNewAddress = async () => {
    try {
      if (!selectedPrescription?.patient_details?.patient_id) {
        showErrorAlert("Please select a patient first");
        return;
      }

      const newAddress = {
        patient_id: selectedPrescription.patient_details.patient_id,
        ...addressData,
      };

      const result = await dispatch(addDeliveryAddress(newAddress));

      if (result.success) {
        setShowAddressModal(false);
        setAddressData({
          phoneNumber: "",
          addressLine1: "",
          addressLine2: "",
          area: "",
          city: "",
          state: "",
          country: "",
          pincode: "",
        });

        if (result.data?.address_id) {
          setSelectedAddressId(result.data.address_id.toString());
        }
      } else {
        showErrorAlert(result.message || "Failed to add address");
      }
    } catch (error) {
      console.error("Error adding address:", error);
      showErrorAlert(
        error.message || "An error occurred while adding the address"
      );
    }
  };

  const handleStatusSelect = (delivery, status) => {
    if (status === "PENDING") {
      handleDeliveryDetailUpdate(delivery, status);
    } else {
      setSelectedDelivery(delivery);
      setNewStatus(status);

      setDeliveryDetails({
        delivery_partner: delivery.delivery_partner || "",
        delivery_code: delivery.delivery_code || "",
        delivery_date: delivery.delivery_date || "",
        delivery_id: delivery.delivery_id || "",
      });
      setShowStatusModal(true);
    }
  };

  // const handleDeliveryDetailUpdate = async (delivery, status, details = {}) => {
  //   try {
  //     const localDeliveryRecord = {
  //       delivery_date:
  //         details.delivery_date ||
  //         delivery.delivery_date ||
  //         new Date().toLocaleString(),
  //       delivery_status: status,
  //       delivery_option: "BY_COURIER",
  //       delivery_partner: details.delivery_partner || delivery.delivery_partner,
  //       delivery_code: details.delivery_code || delivery.delivery_code,
  //       delivery_address_id: delivery.delivery_address_id,
  //       delivery_medicines: delivery.delivery_medicines.map((medicine) => ({
  //         ...medicine,
  //         delivery_status: status,
  //         quantity_delivered: medicine.quantity || medicine.updated_qty,
  //       })),
  //     };

  //     dispatch({
  //       type: "ADD_DELIVERY_DETAIL",
  //       payload: {
  //         prescription_id: selectedPrescription?.prescription_id,
  //         delivery_detail: localDeliveryRecord,
  //       },
  //     });

  //     // const payload = {
  //     //   patient_id: selectedPrescription?.patient_details?.patient_id,
  //     //   prescription_id: selectedPrescription?.prescription_id,
  //     //   delivery_option: "BY_COURIER",
  //     //   delivery_medicines: Object.values(selectedMedicines)
  //     //     .filter((m) => m)
  //     //     .map((m) => m.prescription_medicine_id)
  //     //     .join("|"),
  //     //   delivery_status: status,
  //     //   delivery_partner: details.delivery_partner || delivery.delivery_partner,
  //     //   delivery_code: details.delivery_code || delivery.delivery_code,
  //     //   delivery_date: details.delivery_date || delivery.delivery_date,
  //     //   delivery_address_id: delivery.delivery_address_id || null,
  //     //   delivery_id: delivery.delivery_id || null,
  //     // };
  //     const payload = {
  //       patient_id: selectedPrescription?.patient_details?.patient_id,
  //       prescription_id: selectedPrescription?.prescription_id,
  //       delivery_option: "BY_COURIER",
  //       // ✅ FIX: only update the current medicine, not all
  //       delivery_medicines: selectedMedicineId
  //         ? selectedMedicineId.toString()
  //         : delivery.delivery_medicines
  //             .map((m) => m.prescription_medicine_id)
  //             .join("|"),
  //       delivery_status: status,
  //       delivery_partner: details.delivery_partner || delivery.delivery_partner,
  //       delivery_code: details.delivery_code || delivery.delivery_code,
  //       delivery_date: details.delivery_date || delivery.delivery_date,
  //       delivery_address_id: delivery.delivery_address_id || null,
  //       delivery_id: delivery.delivery_id || null,
  //     };

  //     const result = await dispatch(updateDeliveryStatus(payload));

  //     if (result.success) {
  //       setShowStatusModal(false);

  //       const updatedSelectedMedicines = { ...selectedMedicines };
  //       delivery.delivery_medicines.forEach((medicine) => {
  //         updatedSelectedMedicines[medicine.medicine_id] = {
  //           ...medicine,
  //           delivery_status: status,
  //         };
  //       });
  //       setSelectedMedicines(updatedSelectedMedicines);

  //       handleSuccess("Delivery status updated successfully!");
  //       dispatch(getPrescriptions(statusFilter.value));
  //       dispatch(fetchMedicalDashboardAction());
  //       return;
  //     } else {
  //       showErrorAlert(result.message || "Failed to update delivery status");
  //     }
  //   } catch (error) {
  //     console.error("Error updating delivery status:", error);
  //     showErrorAlert(
  //       error.message || "An error occurred while updating delivery status"
  //     );
  //   }
  // };
  const handleDeliveryDetailUpdate = async (delivery, status, details = {}) => {
    try {
      // ✅ Local update (only update selected medicine, not all)
      const localDeliveryRecord = {
        delivery_date:
          details.delivery_date ||
          delivery.delivery_date ||
          new Date().toLocaleString(),
        delivery_status: status,
        delivery_option: "BY_COURIER",
        delivery_partner: details.delivery_partner || delivery.delivery_partner,
        delivery_code: details.delivery_code || delivery.delivery_code,
        delivery_address_id: delivery.delivery_address_id,
        delivery_medicines: delivery.delivery_medicines.map((medicine) =>
          selectedMedicineId &&
            medicine.prescription_medicine_id !== selectedMedicineId
            ? medicine // leave untouched if not the one we selected
            : {
              ...medicine,
              delivery_status: status,
              quantity_delivered: medicine.quantity || medicine.updated_qty,
            }
        ),
      };

      dispatch({
        type: "ADD_DELIVERY_DETAIL",
        payload: {
          prescription_id: selectedPrescription?.prescription_id,
          delivery_detail: localDeliveryRecord,
        },
      });

      // ✅ API payload (only send the medicine we’re updating)
      const payload = {
        patient_id: selectedPrescription?.patient_details?.patient_id,
        prescription_id: selectedPrescription?.prescription_id,
        delivery_option: "BY_COURIER",
        delivery_medicines: selectedMedicineId
          ? selectedMedicineId.toString()
          : delivery.delivery_medicines
            .map((m) => m.prescription_medicine_id)
            .join("|"),
        delivery_status: status,
        delivery_partner: details.delivery_partner || delivery.delivery_partner,
        delivery_code: details.delivery_code || delivery.delivery_code,
        delivery_date: details.delivery_date || delivery.delivery_date,
        delivery_address_id: delivery.delivery_address_id || null,
        delivery_id: delivery.delivery_id || null,
      };

      console.log("🚚 Sending delivery update payload:", payload);

      const result = await dispatch(updateDeliveryStatus(payload));

      if (result.success) {
        setShowStatusModal(false);

        const updatedSelectedMedicines = { ...selectedMedicines };
        if (selectedMedicineId) {
          updatedSelectedMedicines[selectedMedicineId] = {
            ...updatedSelectedMedicines[selectedMedicineId],
            delivery_status: status,
          };
        }
        setSelectedMedicines(updatedSelectedMedicines);

        handleSuccess("Delivery status updated successfully!");
        dispatch(getPrescriptions(statusFilter.value));
        dispatch(fetchMedicalDashboardAction());
        return;
      } else {
        showErrorAlert(result.message || "Failed to update delivery status");
      }
    } catch (error) {
      console.error("Error updating delivery status:", error);
      showErrorAlert(
        error.message || "An error occurred while updating delivery status"
      );
    }
  };


  const StatusUpdateModal = React.memo(() => {
    const [selectedMedicineId, setSelectedMedicineId] = useState(null);
    const [localDetails, setLocalDetails] = useState({
      delivery_partner: "",
      delivery_code: "",
      delivery_date: "",
    });

    useEffect(() => {
      setLocalDetails({
        delivery_partner: deliveryDetails.delivery_partner || "",
        delivery_code: deliveryDetails.delivery_code || "",
        delivery_date: deliveryDetails.delivery_date || "",
        delivery_id: selectedDelivery?.delivery_id || "",
      });
    }, [showStatusModal]);

    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setLocalDetails((prev) => ({
        ...prev,
        [name]: value,
      }));
    };

    const handleSubmit = () => {
      handleDeliveryDetailUpdate(selectedDelivery, newStatus, localDetails);
    };

    const isToDelivered = newStatus === "DELIVERED"; // Will be true for both PENDING->DELIVERED and DISPATCHED->DELIVERED
    const isPendingToDispatched =
      selectedDelivery?.delivery_status === "PENDING" &&
      newStatus === "DISPATCHED";

    return (
      <Modal show={showStatusModal} onHide={() => setShowStatusModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="d-flex align-items-center">
              <span>Update to </span>
              <span
                className={`badge ${newStatus === "DELIVERED"
                  ? "bg-success"
                  : newStatus === "DISPATCHED"
                    ? "bg-info"
                    : "bg-warning text-dark"
                  } ms-2`}
              >
                {newStatus}
              </span>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={(e) => e.preventDefault()}>
            {(isPendingToDispatched || isToDelivered) && (
              <>
                <div className="mb-3">
                  <label className="form-label">Delivery Partner</label>
                  <input
                    type="text"
                    className="form-control"
                    name="delivery_partner"
                    value={localDetails.delivery_partner}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Delivery Code</label>
                  <input
                    type="text"
                    className="form-control"
                    name="delivery_code"
                    value={localDetails.delivery_code}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </>
            )}
            {isToDelivered && (
              <div className="mb-3">
                <label className="form-label">Delivery Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="delivery_date"
                  value={localDetails.delivery_date}
                  max={new Date().toISOString().split("T")[0]}
                  onChange={handleInputChange}
                  required
                />
              </div>
            )}
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => setShowStatusModal(false)}>
            Cancel
          </Button>
          <Button
            variant={
              newStatus === "DELIVERED"
                ? "success"
                : newStatus === "DISPATCHED"
                  ? "info"
                  : "warning"
            }
            onClick={handleSubmit}
            disabled={
              isPendingToDispatched
                ? !localDetails.delivery_partner || !localDetails.delivery_code
                : isToDelivered
                  ? !localDetails.delivery_partner ||
                  !localDetails.delivery_code ||
                  !localDetails.delivery_date
                  : false
            }
          >
            Update to {newStatus}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  });

  StatusUpdateModal.displayName = "StatusUpdateModal";

  // Add click handler to close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (openDropdownIndex !== null && !event.target.closest(".dropdown")) {
        setOpenDropdownIndex(null);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openDropdownIndex]);

  return (
    <>
      <div className="medical-dashboard">
        <div className="form-head d-flex mb-3 mb-md-4 align-items-start">
          <div className="me-auto d-none d-lg-block">
            <h3 className="text-black font-w600">Welcome to Rohati Ayurved!</h3>
          </div>
        </div>

        {/* Statistics Cards */}
        <div className="row">
          {/* <div className="col-xl-3 col-xxl-6 col-sm-6">
            <div className="card gradient-bx text-white bg-danger rounded">
              <div className="card-body">
                <div className="media align-items-center">
                  <div className="media-body">
                    <p className="mb-1">Total Leads</p>
                    <div className="d-flex flex-wrap">
                      <h2 className="fs-40 font-w600 text-white mb-0 me-3">
                        0
                      </h2>
                    </div>
                  </div>
                  <span className="border rounded-circle p-4">
                    <svg
                      width={34}
                      height={34}
                      viewBox="0 0 34 34"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.6667 0.333311C21.1963 0.264777 18.7993 1.17744 17 2.87164C15.2008 1.17744 12.8038 0.264777 10.3334 0.333311C8.9341 0.337244 7.55292 0.649469 6.28803 1.24778C5.02315 1.84608 3.90564 2.71577 3.01502 3.79498C-0.039984 7.45998 -0.261651 13.3333 1.19668 17.5966C1.21002 17.6266 1.22002 17.6566 1.23335 17.6866C3.91168 25.3333 15.2717 33.6666 17 33.6666C18.6983 33.6666 30.025 25.5166 32.7667 17.6866C32.78 17.6566 32.79 17.6266 32.8034 17.5966C34.2417 13.4016 34.0867 7.51498 30.985 3.79498C30.0944 2.71577 28.9769 1.84608 27.712 1.24778C26.4471 0.649469 25.0659 0.337244 23.6667 0.333311ZM17 30.03C14.6817 28.5233 8.23168 24 5.30335 18.6666H12C12.2743 18.6667 12.5444 18.599 12.7863 18.4696C13.0282 18.3403 13.2344 18.1532 13.3867 17.925L14.83 15.7583L17.0867 22.525C17.1854 22.8207 17.3651 23.0829 17.6054 23.2816C17.8456 23.4803 18.1368 23.6076 18.4458 23.6491C18.7548 23.6906 19.0693 23.6446 19.3535 23.5163C19.6376 23.388 19.8801 23.1825 20.0533 22.9233L22.8917 18.6666H28.6984C25.7684 24 19.3183 28.5233 17 30.03Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div> */}
          <div className="col-xl-3 col-xxl-6 col-sm-6">
            <div className="card gradient-bx text-white bg-info rounded">
              <div className="card-body">
                <div className="media align-items-center">
                  <div className="media-body">
                    <p className="mb-1">Patients with Prescriptions</p>
                    <div className="d-flex flex-wrap">
                      <h2 className="fs-40 font-w600 text-white mb-0 me-3">
                        {patientsPrescriptions}
                      </h2>
                    </div>
                  </div>
                  <span className="border rounded-circle p-4">
                    <svg
                      width={34}
                      height={34}
                      viewBox="0 0 38 38"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M37.3333 15.6666C37.3383 14.7488 37.0906 13.8473 36.6174 13.061C36.1441 12.2746 35.4635 11.6336 34.6501 11.2084C33.8368 10.7831 32.9221 10.5899 32.0062 10.65C31.0904 10.7101 30.2087 11.021 29.4579 11.5489C28.707 12.0767 28.1159 12.8011 27.7494 13.6425C27.3829 14.484 27.255 15.4101 27.3799 16.3194C27.5047 17.2287 27.8774 18.086 28.4572 18.7976C29.0369 19.5091 29.8013 20.0473 30.6667 20.3533V25.6666C30.6667 27.8768 29.7887 29.9964 28.2259 31.5592C26.6631 33.122 24.5435 34 22.3333 34C20.1232 34 18.0036 33.122 16.4408 31.5592C14.878 29.9964 14 27.8768 14 25.6666V23.8666C16.7735 23.4642 19.3097 22.0777 21.1456 19.9603C22.9815 17.8429 23.9946 15.1358 24 12.3333V2.33329C24 1.89127 23.8244 1.46734 23.5118 1.15478C23.1993 0.842221 22.7754 0.666626 22.3333 0.666626H17.3333C16.8913 0.666626 16.4674 0.842221 16.1548 1.15478C15.8423 1.46734 15.6667 1.89127 15.6667 2.33329C15.6667 2.77532 15.8423 3.19924 16.1548 3.5118C16.4674 3.82436 16.8913 3.99996 17.3333 3.99996H20.6667V12.3333C20.6667 14.5434 19.7887 16.663 18.2259 18.2258C16.6631 19.7887 14.5435 20.6666 12.3333 20.6666C10.1232 20.6666 8.00358 19.7887 6.44077 18.2258C4.87797 16.663 4 14.5434 4 12.3333V3.99996H7.33333C7.77536 3.99996 8.19928 3.82436 8.51184 3.5118C8.8244 3.19924 9 2.77532 9 2.33329C9 1.89127 8.8244 1.46734 8.51184 1.15478C8.19928 0.842221 7.77536 0.666626 7.33333 0.666626H2.33333C1.8913 0.666626 1.46738 0.842221 1.15482 1.15478C0.842259 1.46734 0.666664 1.89127 0.666664 2.33329V12.3333C0.672024 15.1358 1.68515 17.8429 3.52106 19.9603C5.35697 22.0777 7.8932 23.4642 10.6667 23.8666V25.6666C10.6667 28.7608 11.8958 31.7283 14.0837 33.9162C16.2717 36.1041 19.2391 37.3333 22.3333 37.3333C25.4275 37.3333 28.395 36.1041 30.5829 33.9162C32.7708 31.7283 34 28.7608 34 25.6666V20.3533C34.9723 20.0131 35.8151 19.3797 36.4122 18.5402C37.0092 17.7008 37.3311 16.6967 37.3333 15.6666Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="col-xl-3 col-xxl-6 col-sm-6">
            <div className="card gradient-bx text-white bg-info rounded">
              <div className="card-body">
                <div className="media align-items-center">
                  <div className="media-body">
                    <p className="mb-1">Appointment Books</p>
                    <div className="d-flex flex-wrap">
                      <h2 className="fs-40 font-w600 text-white mb-0 me-3">
                        76
                      </h2>
                    </div>
                  </div>
                  <span className="border rounded-circle p-4">
                    <svg
                      width={34}
                      height={34}
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0)">
                        <path
                          d="M20 0C8.954 0 0 8.954 0 20C0 31.046 8.954 40 20 40C31.046 40 40 31.046 40 20C40 8.954 31.046 0 20 0ZM28.485 28.485C27.756 29.214 26.744 29.636 25.636 29.636C24.528 29.636 23.516 29.214 22.787 28.485L20 25.697L17.213 28.485C16.484 29.214 15.472 29.636 14.364 29.636C13.256 29.636 12.244 29.214 11.515 28.485C10.786 27.756 10.364 26.744 10.364 25.636C10.364 24.528 10.786 23.516 11.515 22.787L14.302 20L11.515 17.213C10.786 16.484 10.364 15.472 10.364 14.364C10.364 13.256 10.786 12.244 11.515 11.515C12.244 10.786 13.256 10.364 14.364 10.364C15.472 10.364 16.484 10.786 17.213 11.515L20 14.302L22.787 11.515C23.516 10.786 24.528 10.364 25.636 10.364C26.744 10.364 27.756 10.786 28.485 11.515C29.214 12.244 29.636 13.256 29.636 14.364C29.636 15.472 29.214 16.484 28.485 17.213L25.697 20L28.485 22.787C29.214 23.516 29.636 24.528 29.636 25.636C29.636 26.744 29.214 27.756 28.485 28.485Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0">
                          <rect width={40} height={40} fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div> */}
          {/* <div className="col-xl-3 col-xxl-6 col-sm-6">
            <div className="card gradient-bx text-white bg-secondary rounded">
              <div className="card-body">
                <div className="media align-items-center">
                  <div className="media-body">
                    <p className="mb-1">Hospital Earning</p>
                    <div className="d-flex flex-wrap">
                      <h2 className="fs-40 font-w600 text-white mb-0 me-3">
                        ₹
                        {todayPatients
                          .reduce((total, patient) => {
                            const medicines =
                              patient.prescriptions?.medicines || [];
                            return (
                              total +
                              medicines.reduce(
                                (medTotal, med) => medTotal + (med.price || 0),
                                0
                              )
                            );
                          }, 0)
                          .toFixed(2)}
                      </h2>
                    </div>
                  </div>
                  <span className="border rounded-circle p-4">
                    <svg
                      width={34}
                      height={34}
                      viewBox="0 0 21 35"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.21864 35H11.6667V31.7747C17.7104 31.496 21.0001 27.7133 21.0001 23.413C21.0001 17.2412 15.7596 16.0865 11.6667 14.8919V8.72014C12.7378 9.11832 13.4645 10.0341 13.6175 11.5074H20.6175C20.2733 6.45051 16.9072 3.66325 11.6667 3.22526V0H9.21864V3.22526C4.01645 3.58362 6.10352e-05 6.53015 6.10352e-05 11.5074C6.10352e-05 17.7588 5.12574 18.9534 9.21864 20.0683V26.3595C7.91809 25.9215 7.15307 24.9261 7.00006 23.2935H0.0383124C0.229569 28.43 4.01645 31.2571 9.21864 31.7349V35ZM14.1531 23.6519C14.1531 25.1251 13.1968 26.2002 11.6667 26.479V20.8248C13.1585 21.4221 14.1531 22.2184 14.1531 23.6519ZM6.92356 11.1889C6.92356 9.63595 7.80334 8.75995 9.21864 8.52105V14.0557C7.84159 13.4187 6.92356 12.5825 6.92356 11.1889Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div> */}
        </div>

        <div className="row">
          {/* Left side - Patient List - Always visible */}
          <div className="col-xl-4 col-xxl-4 col-lg-4">
            <div
              className="card border-0 pb-0"
              style={{ borderRadius: "10px" }}
            >
              {/* <div className="card-header border-0 pb-0">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                  
                  <h4 className="card-title mb-0 me-3" style={{ whiteSpace: "nowrap" }}>
                    Patients
                  </h4>

                 
                  <div
                    style={{
                      minWidth: "180px",
                      maxWidth: "250px",
                      flexGrow: 1,
                    }}
                  >
                    <Select
                      value={statusFilter}
                      onChange={handleStatusFilterChange}
                      options={[
                        { value: "ALL", label: "All Prescriptions" },
                        { value: "PENDING", label: "Pending" },
                        { value: "DELIVERED", label: "Delivered" },
                      ]}
                      placeholder="Filter by status"
                      classNamePrefix="react-select"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "35px",
                          height: "35px",
                          fontSize: "12px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          fontSize: "12px",
                        }),
                        option: (provided) => ({
                          ...provided,
                          fontSize: "12px",
                        }),
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                        }),
                      }}
                    />
                  </div>
                </div>
                
              </div> */}
              <div className="card-header border-0 pb-2 bg-white">
                <div className="d-flex flex-column gap-2 w-100">
                  {/* Row 1: Title + Filter */}
                  <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                    {/* Title */}
                    <h4
                      className="card-title mb-0 me-3"
                      style={{ whiteSpace: "nowrap", fontWeight: 600 }}
                    >
                      Patients
                    </h4>

                    {/* Filter Dropdown */}
                    <div
                      style={{
                        minWidth: "180px",
                        maxWidth: "250px",
                        flexGrow: 1,
                      }}
                    >
                      <Select
                        value={statusFilter}
                        onChange={handleStatusFilterChange}
                        options={[
                          { value: "ALL", label: "All Prescriptions" },
                          { value: "PENDING", label: "Pending" },
                          { value: "DELIVERED", label: "Delivered" },
                        ]}
                        placeholder="Filter by status"
                        classNamePrefix="react-select"
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            minHeight: "35px",
                            height: "35px",
                            fontSize: "12px",
                            borderRadius: "6px",
                          }),
                          singleValue: (provided) => ({
                            ...provided,
                            fontSize: "12px",
                          }),
                          option: (provided) => ({
                            ...provided,
                            fontSize: "12px",
                          }),
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                        }}
                      />
                    </div>
                  </div>

                  {/* Row 2: Search Bar */}
                  <div className="d-flex align-items-center" style={{ width: "100%" }}>
                    <div className="input-group" style={{ height: "32px" }}>
                      <span
                        className="input-group-text bg-light border-end-0"
                        style={{ padding: "4px 8px", height: "32px" }}
                      >
                        <i className="fa fa-search text-muted"></i>
                      </span>

                      <input
                        type="text"
                        className="form-control border-start-0"
                        placeholder="Search by first name..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                          fontSize: "13px",
                          height: "34px",
                          padding: "4px 8px",
                          borderRadius: "0 6px 6px 0",
                        }}
                      />
                    </div>
                  </div>
                  <div className="row mt-2">

                    {/* Branch */}
                    <div className="col-md-6 mb-2">
                      <Select
                        value={selectedBranch}
                        onChange={(e) => setSelectedBranch(e)}
                        options={[
                          { value: "", label: "All Branches" },
                          ...branches.map((b) => ({
                            value: b.branch_id,
                            label: b.branch_name,
                          })),
                        ]}
                        placeholder="Select Branch"
                        classNamePrefix="react-select"
                        styles={{
                          control: (p) => ({
                            ...p,
                            minHeight: "35px",
                            height: "35px",
                            fontSize: "12px",
                            borderRadius: "6px",
                          }),
                          option: (p) => ({ ...p, fontSize: "12px" }),
                        }}
                      />
                    </div>

                    {/* Mode */}
                    <div className="col-md-6 mb-2">
                      <Select
                        value={modeFilter}
                        onChange={(e) => setModeFilter(e)}
                        options={[
                          { value: "", label: "All Modes" },
                          { value: "ONLINE", label: "Online" },
                          { value: "WALK_IN", label: "Walk-in" },
                        ]}
                        placeholder="Select Mode"
                        classNamePrefix="react-select"
                        styles={{
                          control: (p) => ({
                            ...p,
                            minHeight: "35px",
                            height: "35px",
                            fontSize: "12px",
                            borderRadius: "6px",
                          }),
                          option: (p) => ({ ...p, fontSize: "12px" }),
                        }}
                      />
                    </div>

                    {/* Delivery Option */}
                    <div className="col-md-6 mb-2">
                      <Select
                        value={deliveryOptionFilter}
                        onChange={(e) => setDeliveryOptionFilter(e)}   // <-- फक्त e
                        options={[
                          { value: "", label: "All Delivery Options" },
                          { value: "BY_HAND", label: "By Hand" },
                          { value: "BY_COURIER", label: "By Courier" },
                        ]}
                        placeholder="Delivery Option"
                        classNamePrefix="react-select"
                        styles={{
                          control: (p) => ({
                            ...p,
                            minHeight: "35px",
                            height: "35px",
                            fontSize: "12px",
                            borderRadius: "6px",
                          }),
                          option: (p) => ({ ...p, fontSize: "12px" }),
                        }}
                      />
                    </div>

                    {/* Delivery Status */}
                    <div className="col-md-6 mb-2">
                      <Select
                        value={deliveryStatusFilter}
                        onChange={(e) => setDeliveryStatusFilter(e)}   // <-- फक्त e
                        options={[
                          { value: "", label: "All Delivery Status" },
                          { value: "PENDING", label: "Pending" },
                          { value: "DELIVERED", label: "Delivered" },
                          { value: "FAILED", label: "Failed" },
                        ]}
                        placeholder="Delivery Status"
                        classNamePrefix="react-select"
                        styles={{
                          control: (p) => ({
                            ...p,
                            minHeight: "35px",
                            height: "35px",
                            fontSize: "12px",
                            borderRadius: "6px",
                          }),
                          option: (p) => ({ ...p, fontSize: "12px" }),
                        }}
                      />
                    </div>

                  </div>
                </div>
              </div>


              <div className="card-body">
                <div
                  style={{
                    borderRadius: "10px",
                  }}
                  className="widget-media dz-scroll"
                >
                  <ul className="timeline">
                    {/* Show loading indicator when filter is changing */}
                    {isFilterLoading ? (
                      <div className="text-center py-4">
                        <Loader />
                        <p className="mt-2 text-muted">
                          Loading prescriptions...
                        </p>
                      </div>
                    ) : filteredPatients.length > 0 ? (
                      (console.log("todayPatients", todayPatients),
                        filteredPatients
                          .filter((patient) => {
                            if (!searchTerm.trim()) return true;
                            const firstName =
                              patient.prescriptions?.patient_details?.first_name?.toLowerCase() || "";
                            return firstName.includes(searchTerm.toLowerCase());
                          })
                          .map((patient) => (
                            <li
                              key={patient.id}
                              style={{
                                backgroundColor:
                                  selectedPrescription?.prescription_id ===
                                    patient.prescriptions.prescription_id
                                    ? "#e3f2fd"
                                    : "transparent",
                                margin: "0 0 15px 0",
                                borderRadius: "12px",
                                cursor: "pointer",
                                transition: "all 0.3s ease",
                                border: "none",
                                listStyle: "none",
                              }}
                              onClick={() => handlePatientSelect(patient)}
                            >
                              <div
                                className="timeline-panel d-flex align-items-center py-2"
                                style={{
                                  borderRadius: "12px",
                                  backgroundColor: "transparent",
                                  padding: "20px",
                                  transition: "all 0.3s ease",
                                  width: "100%",
                                }}
                              >
                                {/* Avatar Section */}
                                <div className="media rounded-circle me-3">
                                  <Link
                                  //to={`/patients/patient-details/${patient.patient_id}`}
                                  >
                                    {/* {typeof patient.avatar === "string" ? (
                                    <div
                                      className="media-info"
                                      style={{
                                        borderRadius: "50%",
                                        width: "50px",
                                        height: "50px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: "#f8f9fa",
                                        fontSize: "18px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      {patient.avatar}
                                    </div>
                                  ) : ( */}
                                    <img
                                      alt="avatar"
                                      width="50"
                                      height="50"
                                      src={patient.avatar && patient.avatar.trim() !== "" ? patient.avatar : avatar1}
                                      onError={(e) => {
                                        e.target.onerror = null; // prevent infinite loop
                                        e.target.src = avatar1;
                                      }}
                                      style={{
                                        borderRadius: "50%",
                                        objectFit: "cover",
                                      }}
                                    />


                                  </Link>
                                </div>

                                {/* Patient Info Section */}
                                <div className="media-body flex-grow-1">
                                  <h5
                                    className="mb-2"
                                    style={{
                                      color:
                                        selectedPrescription?.prescription_id ===
                                          patient.prescriptions.prescription_id
                                          ? "#1976d2"
                                          : "#333",
                                      fontWeight: "600",
                                      fontSize: "16px",
                                    }}
                                  >
                                    {patient.name}
                                  </h5>
                                  <p
                                    className="mb-1 text-muted"
                                    style={{ fontSize: "14px" }}
                                  >
                                    <strong>Disease:</strong>{" "}
                                    {selectedPrescription?.diseases
                                      ?.map((disease) => disease.disease_name)
                                      .join(", ") || "N/A"}
                                  </p>
                                  <p
                                    className="mb-1 text-muted"
                                    style={{ fontSize: "14px" }}
                                  >
                                    <strong>Doctor:</strong> {patient.prescribeBy}
                                  </p>
                                  <p
                                    className="mb-1 text-muted"
                                    style={{ fontSize: "14px" }}
                                  >
                                    <strong>Date:</strong>{" "}
                                    {patient.prescribeDate
                                      ? formatDate(patient.prescribeDate)
                                      : "N/A"}

                                  </p>
                                  {/* <p
                                    className="mb-1 text-muted"
                                    style={{ fontSize: "14px" }}
                                  >
                                    <strong>Delivery:</strong>{" "}
                                    {patient.prescriptions?.delivery_details?.length > 0
                                      ? formatDate(patient.prescriptions.delivery_details.at(-1).delivery_date, false, true)
                                      : "Not Delivered"}

                                  </p> */}
                                  <div className="d-flex align-items-center mt-2">
                                    <span
                                      className={`badge ${patient.status === "DELEVERD"
                                        ? "bg-success"
                                        : patient.status === "PENDING"
                                          ? "bg-warning"
                                          : "bg-secondary"
                                        }`}
                                      style={{ fontSize: "12px" }}
                                    >
                                      {patient.status}
                                    </span>
                                    {/* <Link
                                    className="btn btn-outline-primary btn-sm ms-2"
                                    style={{
                                      padding: "4px 12px",
                                      fontSize: "12px",
                                      borderRadius: "6px",
                                    }}
                                  >
                                    View Details
                                </Link> */}
                                  </div>
                                </div>

                                {/* Action Icon Section */}
                                <Link
                                  onClick={() =>
                                    handleViewPatient(patient.prescriptions.prescription_id)
                                  }
                                  className="btn btn-light btn-sm rounded-circle"
                                  style={{
                                    width: "36px",
                                    height: "36px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    border: "none",
                                    backgroundColor:
                                      selectedPrescription?.prescription_id ===
                                        patient.prescriptions.prescription_id
                                        ? "#1976d2"
                                        : "#f8f9fa",
                                    color:
                                      selectedPrescription?.prescription_id ===
                                        patient.prescriptions.prescription_id
                                        ? "white"
                                        : "#666",
                                    transition: "all 0.3s ease",
                                    cursor: "pointer",
                                  }}
                                  title="View Patient"
                                >
                                  <i
                                    className="fa fa-chevron-right"
                                    style={{ fontSize: "12px" }}
                                  ></i>
                                </Link>
                              </div>
                            </li>

                          )))
                    ) : (
                      <div className="text-center py-4">
                        <div className="alert alert-info" role="alert">
                          <i className="fa fa-info-circle fa-2x mb-3"></i>
                          <h5>No Patients with Prescriptions</h5>
                          <p className="mb-0">
                            There are no patients with prescriptions at the
                            moment.
                          </p>
                        </div>
                      </div>
                    )}
                  </ul>
                </div>

                {/* Delivery History Section */}
                {/* {selectedPrescription?.delivery_details &&
                selectedPrescription.delivery_details.length > 0 && (
                  <div className="card border-0 pb-0 mt-3">
                    <div className="card-header border-0 pb-0">
                      <h4 className="card-title">Delivery History</h4>
                    </div>
                    <div className="card-body">
                      <div className="accordion" id="deliveryHistoryAccordion">
                        {[...selectedPrescription.delivery_details]
                          .sort(
                            (a, b) =>
                              new Date(b.delivery_date) -
                              new Date(a.delivery_date)
                          )
                          .map((delivery, index) => (
                            <div
                              className="accordion-item"
                              key={index}
                              style={deliveryHistoryStyles.accordionItem}
                            >
                              <h2
                                className="accordion-header"
                                id={`heading${index}`}
                              >
                                <button
                                  className="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target={`#collapse${index}`}
                                  aria-expanded="false"
                                  aria-controls={`collapse${index}`}
                                  style={deliveryHistoryStyles.accordionButton}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor =
                                      deliveryHistoryStyles.accordionButtonHover.backgroundColor;
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor =
                                      deliveryHistoryStyles.accordionButton.backgroundColor;
                                  }}
                                >
                                  <div className="d-flex justify-content-between align-items-center w-100">
                                    <div>
                                      <strong>Date:</strong>{" "}
                                      {new Date(
                                        delivery.delivery_date
                                      ).toLocaleDateString()}
                                    </div>
                                    <span
                                      className={`badge ${
                                        delivery.delivery_status === "DELIVERED"
                                          ? "bg-success"
                                          : delivery.delivery_status ===
                                            "PENDING"
                                          ? "bg-warning"
                                          : "bg-info"
                                      }`}
                                      style={deliveryHistoryStyles.badge}
                                    >
                                      {delivery.delivery_status}
                                    </span>
                                  </div>
                                </button>
                              </h2>
                              <div
                                id={`collapse${index}`}
                                className="accordion-collapse collapse"
                                aria-labelledby={`heading${index}`}
                                data-bs-parent="#deliveryHistoryAccordion"
                              >
                                <div
                                  className="accordion-body"
                                  style={deliveryHistoryStyles.accordionBody}
                                >
                                  <div className="delivery-details">
                                    <div className="row mb-2">
                                      <div className="col-md-6">
                                        <p className="mb-1">
                                          <strong>Delivery Partner:</strong>{" "}
                                          {delivery.delivery_partner || "N/A"}
                                        </p>
                                        <p className="mb-1">
                                          <strong>Delivery Code:</strong>{" "}
                                          {delivery.delivery_code || "N/A"}
                                        </p>
                                      </div>
                                      <div className="col-md-6">
                                        <p className="mb-1">
                                          <strong>Delivery Date:</strong>{" "}
                                          {new Date(
                                            delivery.delivery_date
                                          ).toLocaleString()}
                                        </p>
                                        <p className="mb-1">
                                          <strong>Status:</strong>{" "}
                                          <span
                                            className={`badge ${
                                              delivery.delivery_status ===
                                              "DELIVERED"
                                                ? "bg-success"
                                                : delivery.delivery_status ===
                                                  "PENDING"
                                                ? "bg-warning"
                                                : "bg-info"
                                            }`}
                                          >
                                            {delivery.delivery_status}
                                          </span>
                                        </p>
                                      </div>
                                    </div>

                                    {delivery.delivery_medicines &&
                                      delivery.delivery_medicines.length >
                                        0 && (
                                        <div className="medicines-list mt-3">
                                          <h6 className="mb-2">
                                            Delivered Medicines:
                                          </h6>
                                          <div className="table-responsive">
                                            <table
                                              className="table table-bordered table-sm"
                                              style={
                                                deliveryHistoryStyles.medicineTable
                                              }
                                            >
                                              <thead className="bg-light">
                                                <tr>
                                                  <th>Medicine Name</th>
                                                  <th>Quantity</th>
                                                  <th>Instructions</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {selectedPrescription.prescriptions?.delivery_medicines.map(
                                                  (medicine, medIndex) => (
                                                    <tr key={medIndex}>
                                                      <td>
                                                        {medicine.medicine_name ||
                                                          medicine.name}
                                                      </td>
                                                      <td>
                                                        {medicine.quantity_delivered ||
                                                          medicine.quantity ||
                                                          "N/A"}
                                                      </td>
                                                      <td>
                                                        {medicine.instructions ||
                                                          medicine.how_to_take ||
                                                          "N/A"}
                                                      </td>
                                                    </tr>
                                                  )
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                )} */}
              </div>
            </div>
          </div>

          {/* Right side - Prescription Details - Show loader here */}
          <div className="col-xl-8 col-xxl-8 col-lg-8" ref={prescriptionRef}>
            {selectedPrescription ? (
              <div className="card border-0 shadow-sm">
                <div className="card-header bg-white border-0 pb-3 d-flex justify-content-between align-items-center">
                  <div>
                    <h4 className="card-title mb-1 text-primary">
                      Prescription Details
                      {disableActions && (
                        <span className="badge bg-danger ms-2">
                          Invalid Prescription
                        </span>
                      )}

                    </h4>
                  </div>
                  <div className="text-end">
                    <div
                      className="d-flex align-items-end flex-wrap"
                      style={{ gap: "12px" }}
                    >
                      <p className="mb-1" style={{ fontSize: "14px" }}>
                        <strong className="text-primary">Patient:</strong>{" "}
                        <span className="text-dark">
                          {selectedPrescription?.patient_details?.first_name || "No Patient Selected"}
                          {selectedPrescription?.patient_details?.last_name &&
                            ` ${selectedPrescription.patient_details.last_name}`}
                        </span>
                      </p>

                      <p className="mb-1" style={{ fontSize: "14px" }}>
                        <strong className="text-primary">Disease:</strong>{" "}
                        <span>
                          {selectedPrescription?.diseases
                            ?.map((disease) => disease.disease_name)
                            .join(", ") || "N/A"}
                        </span>
                      </p>

                      <p className="mb-1" style={{ fontSize: "14px" }}>
                        <strong className="text-primary">Phone:</strong>{" "}
                        <span>
                          {selectedPrescription?.patient_details?.whatsapp_contact_no || "--"}
                        </span>
                        {selectedPrescription?.patient_details?.whatsapp_contact_no && (
                          <a
                            href={`tel:${selectedPrescription.patient_details.whatsapp_contact_no}`}
                            className="btn btn-success btn-sm ms-2 px-2 py-0"
                            style={{ borderRadius: "20px", fontSize: "12px" }}
                          >
                            <i className="fa fa-phone"></i>
                          </a>
                        )}
                      </p>

                      <p className="mb-1" style={{ fontSize: "14px" }}>
                        <strong className="text-primary">Service Caller:</strong>{" "}
                        <span className="text-dark">-</span>
                      </p>
                    </div>

                  </div>
                </div>
                <div
                  className="card-body"
                  style={{ position: "relative", minHeight: "200px", overflowX: "hidden", whiteSpace: "normal", wordBreak: "break-word", }}
                >
                  {loading && (
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(255, 255, 255, 0.9)",
                        //zIndex: 1000,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                      }}
                    >
                      <Loader />
                      <p
                        className="mt-3"
                        style={{
                          color: "#333",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      >
                        Loading prescription details...
                      </p>
                    </div>
                  )}
                  <div className="d-flex justify-content-between align-items-center mt-2">
                    <p
                      className="prescription-duration mb-0 text-muted"
                      style={{
                        fontWeight: 500,
                        marginBottom: 0,
                        color: "gray",
                      }}
                    >
                      <strong>Prescription Duration:</strong>{" "}
                      {selectedPrescription?.duration
                        ? getDurationLabel(selectedPrescription.duration)
                        : "-"}
                    </p>

                    <p
                      className="prescription-branch mb-0 text-muted"
                      style={{ fontWeight: 500, marginBottom: 0, color: "gray" }}
                    >
                      <strong>Branch:</strong>{" "}
                      <span>{branchName}</span>
                    </p>


                    <button
                      onClick={handleDownload}
                      className="btn btn-info d-flex align-items-center justify-content-center"
                      style={{ height: "45px", minWidth: "130px" }}
                      title="Download prescription as PDF"
                      disabled={isDownloading}   // Disable while downloading
                    >
                      {isDownloading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          Downloading...
                        </>
                      ) : (
                        "Download"
                      )}
                    </button>

                  </div>

                  {/* Error display */}
                  {error && (
                    <Alert variant="danger" className="mt-3">
                      <strong>Error:</strong> {error}
                    </Alert>
                  )}
                  {/* Separate medicines into custom and non-custom */}
                  {(() => {
                    const medicines =
                      selectedPrescription?.medicines &&
                        selectedPrescription.medicines.length > 0
                        ? selectedPrescription.medicines
                        : prescriptions;

                    const regularMedicines = medicines.filter(
                      (medicine) => medicine.is_custom === "No"
                    );
                    const customMedicines = medicines.filter(
                      (medicine) => medicine.is_custom === "Yes"
                    );

                    return (
                      <>
                        {/* Regular Medicines Table */}
                        {regularMedicines.length > 0 && (
                          <div
                            style={{
                              border: "2px solid #ddd",
                              borderRadius: "5px",
                              marginTop: "20px",
                              marginBottom: "24px",
                            }}
                          >
                            <div className="table-responsive">
                              <table
                                className="table table-bordered table-sm text-center align-middle mb-0"
                                style={{ borderCollapse: "collapse" }}
                              >
                                <thead
                                  className="bg-light"
                                  style={{
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 1,
                                    borderBottom: "2px solid #ddd",
                                  }}
                                >
                                  <tr className="table-info">
                                    <th className="text-nowrap fw-bold text-dark">
                                      Medicine Name
                                    </th>
                                    <th className="text-nowrap fw-bold text-dark">
                                      Dose
                                    </th>
                                    <th className="text-nowrap fw-bold text-dark">
                                      Frequency
                                    </th>
                                    <th className="text-nowrap fw-bold text-dark">
                                      Quantity
                                    </th>
                                    <th className="text-nowrap fw-bold text-dark">
                                      Delivered Qty
                                    </th>
                                    <th className="fw-bold text-dark"></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {regularMedicines.map((medicine, index) => {
                                    const deliveryDetail =
                                      selectedPrescription?.delivery_details?.find(
                                        (detail) =>
                                          detail.delivery_medicines?.some(
                                            (med) =>
                                              med.medicine_id ===
                                              medicine.medicine_id
                                          )
                                      );

                                    const isProcessed = !!deliveryDetail;
                                    const deliveryStatus =
                                      deliveryDetail?.delivery_status || "";

                                    if (
                                      isProcessed &&
                                      !selectedMedicines[medicine.medicine_id]
                                    ) {
                                      handleMedicineSelect(medicine, true);
                                    }

                                    return (
                                      <tr
                                        key={`regular-${medicine.medicine_id || index
                                          }`}
                                        style={{
                                          backgroundColor: isProcessed
                                            ? "#f8f9fa"
                                            : selectedMedicines[medicine.medicine_id]?.delivery_status === "CONFIRM"
                                              ? "#f8f9fa"
                                              : "white",
                                          transition: "all 0.3s ease",
                                          borderLeft: isProcessed
                                            ? "4px solid #17a2b8"
                                            : selectedMedicines[medicine.medicine_id]?.delivery_status === "CONFIRM"
                                              ? "4px solid #17a2b8"
                                              : "4px solid transparent",
                                          opacity: isProcessed ? 0.8 : 1,
                                        }}
                                      >
                                        <td>
                                          <div className="d-flex align-items-center gap-2">
                                            <span
                                              style={{
                                                color: isProcessed
                                                  ? "#6c757d"
                                                  : "inherit",
                                              }}
                                            >
                                              {medicine.medicine_name ||
                                                medicine.name}
                                            </span>
                                            <i
                                              className="fa fa-info-circle text-primary"
                                              style={{
                                                cursor: "pointer",
                                                opacity: isProcessed ? 0.6 : 1,
                                              }}
                                              data-tooltip-id={`tooltip-regular-${index}`}
                                              data-tooltip-content={
                                                isProcessed
                                                  ? `Status: ${deliveryStatus}`
                                                  : "Not processed yet"
                                              }
                                            ></i>
                                          </div>
                                          <Tooltip
                                            id={`tooltip-regular-${index}`}
                                            style={{ zIndex: 9999 }}
                                            place="right"
                                          />
                                        </td>
                                        <td
                                          style={{
                                            color: isProcessed
                                              ? "#6c757d"
                                              : "inherit",
                                          }}
                                        >
                                          {medicine.dose ||
                                            medicine.dosage ||
                                            "N/A"}
                                        </td>
                                        <td
                                          style={{
                                            color: isProcessed
                                              ? "#6c757d"
                                              : "inherit",
                                          }}
                                        >
                                          {medicine.frequency || "N/A"}
                                        </td>
                                        <td
                                          style={{
                                            color: isProcessed
                                              ? "#6c757d"
                                              : "inherit",
                                          }}
                                        >
                                          {medicine.updated_qty || "N/A"}
                                        </td>
                                        <td>
                                          <span
                                            style={{
                                              color: isProcessed
                                                ? "#28a745"
                                                : "inherit",
                                            }}
                                          >
                                            {medicine.updated_qty || "N/A"}
                                          </span>
                                        </td>
                                        <td>
                                          <div className="d-flex justify-content-center">
                                            {/* <input
                                              className="form-check-input"
                                              type="checkbox"
                                              style={{
                                                width: "18px",
                                                height: "18px",
                                                cursor: isProcessed
                                                  ? "not-allowed"
                                                  : "pointer",
                                                borderColor: isProcessed
                                                  ? "#28a745"
                                                  : selectedMedicines[
                                                    medicine.medicine_id
                                                  ]
                                                    ? "#28a745"
                                                    : "#dee2e6",
                                                backgroundColor: isProcessed
                                                  ? "#28a745"
                                                  : selectedMedicines[
                                                    medicine.medicine_id
                                                  ]
                                                    ? "#28a745"
                                                    : "white",
                                                margin: 0,
                                                opacity: isProcessed ? 0.8 : 1,
                                              }}
                                              checked={
                                                isProcessed ||
                                                !!selectedMedicines[
                                                medicine.medicine_id
                                                ]
                                              }
                                              onChange={(e) =>
                                                !isProcessed &&
                                                handleMedicineSelect(
                                                  medicine,
                                                  e.target.checked
                                                )
                                              }
                                              disabled={
                                                isProcessed ||
                                                loading ||
                                                updateLoading
                                              }
                                            /> */}

                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              style={{
                                                width: "18px",
                                                height: "18px",
                                                cursor: isProcessed ? "not-allowed" : "pointer",
                                                borderColor: isProcessed
                                                  ? "#28a745"
                                                  : selectedMedicines[medicine.medicine_id]?.delivery_status === "CONFIRM"
                                                    ? "#28a745"
                                                    : "#dee2e6",
                                                backgroundColor: isProcessed
                                                  ? "#28a745"
                                                  : selectedMedicines[medicine.medicine_id]?.delivery_status === "CONFIRM"
                                                    ? "#28a745"
                                                    : "white",
                                                margin: 0,
                                                opacity: isProcessed ? 0.8 : 1,
                                              }}
                                              checked={
                                                isProcessed ||
                                                selectedMedicines[medicine.medicine_id]?.delivery_status === "CONFIRM"
                                              }
                                              onChange={(e) => {
                                                if (isProcessed) return; // skip delivered

                                                setSelectedMedicines((prev) => {
                                                  const updated = { ...prev };
                                                  const current = prev[medicine.medicine_id]?.delivery_status;

                                                  if (e.target.checked) {
                                                    updated[medicine.medicine_id] = {
                                                      ...medicine,
                                                      delivery_status: "CONFIRM",
                                                    };
                                                  } else {
                                                    updated[medicine.medicine_id] = {
                                                      ...medicine,
                                                      delivery_status: "PENDING", // revert back to pending
                                                    };
                                                  }

                                                  return updated;
                                                });
                                              }}
                                              disabled={isProcessed || loading || updateLoading || disableActions}
                                            />




                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        )}

                        {/* Custom Medicines Table */}
                        {customMedicines.length > 0 && (
                          <div
                            style={{
                              border: "2px solid #ddd",
                              borderRadius: "5px",
                              marginBottom: "0",
                            }}
                          >
                            <h5 className="p-2 border-bottom mb-0">
                              Custom Medicines
                            </h5>
                            <div className="table-responsive">
                              <table
                                className="table header-border"
                                style={{
                                  width: "100%",
                                  borderCollapse: "collapse",
                                  textAlign: "center",
                                }}
                              >
                                <thead
                                  style={{
                                    position: "sticky",
                                    top: 0,
                                    backgroundColor: "#f8f9fa",
                                    //zIndex: 10,
                                    borderBottom: "2px solid #ddd",
                                  }}
                                >
                                  <tr className="table-info">
                                    <th
                                      style={{
                                        padding: "10px",
                                        fontWeight: "bold",
                                        color: "black",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      Medicine Name
                                    </th>
                                    <th
                                      style={{
                                        padding: "10px",
                                        fontWeight: "bold",
                                        color: "black",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      Dose
                                    </th>
                                    <th
                                      style={{
                                        padding: "10px",
                                        fontWeight: "bold",
                                        color: "black",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      Frequency
                                    </th>
                                    <th
                                      style={{
                                        padding: "10px",
                                        fontWeight: "bold",
                                        color: "black",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      Quantity
                                    </th>
                                    <th
                                      style={{
                                        padding: "10px",
                                        fontWeight: "bold",
                                        color: "black",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      Duration
                                    </th>
                                    <th
                                      style={{
                                        padding: "10px",
                                        fontWeight: "bold",
                                        color: "black",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      Delivered Qty
                                    </th>
                                    <th
                                      style={{
                                        padding: "10px",
                                        fontWeight: "bold",
                                        color: "black",
                                      }}
                                    ></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {customMedicines.map((medicine, index) => {
                                    // Check if medicine is in delivery_details
                                    const deliveryDetail =
                                      selectedPrescription?.delivery_details?.find(
                                        (detail) =>
                                          detail.delivery_medicines?.some(
                                            (med) =>
                                              med.medicine_id ===
                                              medicine.medicine_id
                                          )
                                      );

                                    const isProcessed = !!deliveryDetail;
                                    const deliveryStatus =
                                      deliveryDetail?.delivery_status || "";

                                    // If medicine is in delivery_details, pre-select it
                                    if (
                                      isProcessed &&
                                      !selectedMedicines[medicine.medicine_id]
                                    ) {
                                      handleMedicineSelect(medicine, true);
                                    }

                                    return (
                                      <tr
                                        key={`custom-${medicine.medicine_id || index
                                          }`}
                                        className="align-middle"
                                        style={{
                                          height: "60px",
                                          backgroundColor: isProcessed
                                            ? "#f8f9fa"
                                            : selectedMedicines[medicine.medicine_id]?.delivery_status === "CONFIRM"
                                              ? "#f8f9fa"
                                              : "white",
                                          transition: "all 0.3s ease",
                                          borderLeft: isProcessed
                                            ? "4px solid #17a2b8"
                                            : selectedMedicines[medicine.medicine_id]?.delivery_status === "CONFIRM"
                                              ? "4px solid #17a2b8"
                                              : "4px solid transparent",
                                          opacity: isProcessed ? 0.8 : 1,
                                        }}
                                      >
                                        <td
                                          style={{
                                            padding: "10px",
                                            verticalAlign: "middle",
                                          }}
                                        >
                                          <div className="d-flex align-items-center gap-2">
                                            <div>
                                              <span
                                                style={{
                                                  color: isProcessed
                                                    ? "#6c757d"
                                                    : "inherit",
                                                }}
                                              >
                                                {medicine.medicine_name ||
                                                  medicine.name}
                                              </span>
                                            </div>
                                            <i
                                              className="fa fa-info-circle text-primary"
                                              style={{
                                                cursor: "pointer",
                                                opacity: isProcessed ? 0.6 : 1,
                                              }}
                                              data-tooltip-id={`tooltip-custom-${index}`}
                                              data-tooltip-content={
                                                isProcessed
                                                  ? `Status: ${deliveryStatus}`
                                                  : "Not processed yet"
                                              }
                                            ></i>
                                          </div>
                                          <Tooltip
                                            id={`tooltip-custom-${index}`}
                                            style={{ zIndex: 9999 }}
                                            place="right"
                                          />
                                        </td>
                                        <td
                                          style={{
                                            padding: "10px",
                                            verticalAlign: "middle",
                                            textAlign: "center",
                                            color: isProcessed
                                              ? "#6c757d"
                                              : "inherit",
                                          }}
                                        >
                                          <span>
                                            {medicine.dose ||
                                              medicine.dosage ||
                                              "N/A"}
                                          </span>
                                        </td>
                                        <td
                                          style={{
                                            padding: "10px",
                                            verticalAlign: "middle",
                                            textAlign: "center",
                                            color: isProcessed
                                              ? "#6c757d"
                                              : "inherit",
                                          }}
                                        >
                                          <span>
                                            {medicine.frequency || "N/A"}
                                          </span>
                                        </td>
                                        <td
                                          style={{
                                            padding: "10px",
                                            verticalAlign: "middle",
                                            textAlign: "center",
                                            color: isProcessed
                                              ? "#6c757d"
                                              : "inherit",
                                          }}
                                        >
                                          <span>
                                            {medicine.updated_qty || "N/A"}
                                          </span>
                                        </td>
                                        <td
                                          style={{
                                            padding: "10px",
                                            verticalAlign: "middle",
                                            textAlign: "center",
                                            color: isProcessed
                                              ? "#6c757d"
                                              : "inherit",
                                          }}
                                        >
                                          <span>
                                            {medicine.custom_duration_in_days ||
                                              "N/A"}
                                          </span>
                                        </td>
                                        <td
                                          style={{
                                            padding: "10px",
                                            verticalAlign: "middle",
                                          }}
                                        >
                                          <span
                                            style={{
                                              color: isProcessed
                                                ? "#28a745"
                                                : "inherit",
                                            }}
                                          >
                                            {medicine.updated_qty || "N/A"}
                                          </span>
                                        </td>
                                        <td
                                          style={{
                                            padding: "10px",
                                            verticalAlign: "middle",
                                            textAlign: "center",
                                          }}
                                        >
                                          <div className="d-flex justify-content-center">
                                            {/* <input
                                            className="form-check-input"
                                            type="checkbox"
                                            style={{
                                              width: "18px",
                                              height: "18px",
                                              cursor: isProcessed
                                                ? "not-allowed"
                                                : "pointer",
                                              borderColor: isProcessed
                                                ? "#28a745"
                                                : selectedMedicines[
                                                  medicine.medicine_id
                                                ]
                                                  ? "#28a745"
                                                  : "#dee2e6",
                                              backgroundColor: isProcessed
                                                ? "#28a745"
                                                : selectedMedicines[
                                                  medicine.medicine_id
                                                ]
                                                  ? "#28a745"
                                                  : "white",
                                              transition: "all 0.3s ease",
                                              margin: 0,
                                              opacity: isProcessed ? 0.8 : 1,
                                            }}
                                            checked={
                                              isProcessed ||
                                              !!selectedMedicines[
                                              medicine.medicine_id
                                              ]
                                            }
                                            onChange={(e) =>
                                              !isProcessed &&
                                              handleMedicineSelect(
                                                medicine,
                                                e.target.checked
                                              )
                                            }
                                            disabled={
                                              isProcessed ||
                                              loading ||
                                              updateLoading
                                            }
                                          /> */}
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              style={{
                                                width: "18px",
                                                height: "18px",
                                                cursor: isProcessed ? "not-allowed" : "pointer",
                                                borderColor: isProcessed
                                                  ? "#28a745"
                                                  : selectedMedicines[medicine.medicine_id]?.delivery_status === "CONFIRM"
                                                    ? "#28a745"
                                                    : "#dee2e6",
                                                backgroundColor: isProcessed
                                                  ? "#28a745"
                                                  : selectedMedicines[medicine.medicine_id]?.delivery_status === "CONFIRM"
                                                    ? "#28a745"
                                                    : "white",
                                                transition: "all 0.3s ease",
                                                margin: 0,
                                                opacity: isProcessed ? 0.8 : 1,
                                              }}
                                              checked={
                                                isProcessed ||
                                                selectedMedicines[medicine.medicine_id]?.delivery_status === "CONFIRM"
                                              }
                                              onChange={(e) => {
                                                if (isProcessed) return; // delivered cannot change

                                                setSelectedMedicines((prev) => {
                                                  const updated = { ...prev };

                                                  if (e.target.checked) {
                                                    // user re-checked → mark for delivery
                                                    updated[medicine.medicine_id] = {
                                                      ...medicine,
                                                      delivery_status: "CONFIRM",
                                                    };
                                                  } else {
                                                    // unchecked → keep in state but mark as "not confirmed"
                                                    updated[medicine.medicine_id] = {
                                                      ...medicine,
                                                      delivery_status: "PENDING",
                                                    };
                                                  }

                                                  return updated;
                                                });
                                              }}
                                              disabled={isProcessed || loading || updateLoading || disableActions}
                                            />



                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        )}

                        {/* Show message if no medicines */}
                        {regularMedicines.length === 0 &&
                          customMedicines.length === 0 && (
                            <div className="text-center text-muted py-4">
                              No prescription data available
                            </div>
                          )}
                      </>
                    );
                  })()}

                  <div style={{ marginTop: "20px" }}>
                    <div className="row mb-3">
                      {/* Only show delivery options if not all medicines are delivered */}
                      {!areAllMedicinesDelivered && (
                        <>
                          {/* Delivery Option Dropdown and Label */}
                          <div className="col-md-6 mb-3 d-flex align-items-center">
                            <label
                              htmlFor="deliveryOption"
                              className="form-label me-3 mb-0"
                            >
                              Delivery Option
                            </label>
                            <div style={{ flex: 1 }}>
                              <Select
                                name="deliveryOption"
                                options={[
                                  { value: "By Hand", label: "By Hand" },
                                  { value: "By Courier", label: "By Courier" },
                                ]}
                                value={
                                  formData.deliveryOption
                                    ? {
                                      value: formData.deliveryOption,
                                      label: formData.deliveryOption,
                                    }
                                    : null
                                }
                                onChange={handleDeliveryOptionChange}
                                placeholder="Select Delivery Option"
                                isDisabled={disableActions}
                                styles={{
                                  control: (provided) => ({
                                    ...provided,
                                    minHeight: "50px",
                                    height: "50px",
                                    display: "flex",
                                    alignItems: "center",
                                  }),
                                  singleValue: (provided) => ({
                                    ...provided,
                                    lineHeight: "50px",
                                  }),
                                  dropdownIndicator: (provided) => ({
                                    ...provided,
                                    padding: "4px",
                                  }),
                                  indicatorSeparator: (provided) => ({
                                    ...provided,
                                    display: "none",
                                  }),
                                }}
                              />
                            </div>
                          </div>

                          {/* Buttons */}
                          <div className="col-md-6 mb-3 d-flex align-items-center justify-content-end">
                            {formData.deliveryOption === "By Hand" && (
                              <Button
                                variant="info"
                                onClick={handleMarkAsDelivered}
                                disabled={
                                  disableActions ||
                                  updateLoading ||
                                  !Object.values(selectedMedicines).some(
                                    (med) =>
                                      !med?.delivery_status ||
                                      med?.delivery_status !== "DELIVERED"
                                  )
                                }
                                style={{ height: "50px" }}
                              >
                                {updateLoading
                                  ? "Processing..."
                                  : "Mark as Delivered"}
                              </Button>
                            )}
                          </div>
                        </>
                      )}
                    </div>

                    {/* Address Layout with Left (Current Address) and Right (Edit/Add Address) */}
                    <Row>
                      <Row>
                        <Col md={12}>
                          {formData.deliveryOption === "By Courier" && (
                            <div>
                              <h4>Select Delivery Address</h4>
                              <div className="address-selection-container">
                                {selectedPrescription?.patient_details
                                  ?.addresses &&
                                  selectedPrescription.patient_details.addresses
                                    .length > 0 ? (
                                  selectedPrescription.patient_details.addresses.map(
                                    (address, index) => (
                                      <div
                                        key={address.address_id || index}
                                        className="form-check mb-2 w-100"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          padding: "10px",
                                          border: "1px solid #dee2e6",
                                          borderRadius: "4px",
                                          backgroundColor:
                                            selectedAddressId ===
                                              (address.address_id?.toString() ||
                                                index.toString())
                                              ? "#f8f9fa"
                                              : "white",
                                        }}
                                      >
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name="deliveryAddress"
                                          id={`address-${address.address_id || index
                                            }`}
                                          value={address.address_id || index}
                                          checked={
                                            selectedAddressId ===
                                            (address.address_id?.toString() ||
                                              index.toString())
                                          }
                                          onChange={(e) =>
                                            setSelectedAddressId(e.target.value)
                                          }
                                          style={{
                                            marginRight: "15px",
                                            marginLeft: "30px",
                                          }}
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor={`address-${address.address_id || index
                                            }`}
                                          style={{
                                            margin: 0,
                                            display: "flex",
                                            alignItems: "center",
                                            flexWrap: "nowrap",
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            cursor: "pointer",
                                            flex: 1,
                                          }}
                                        >
                                          <span style={{ fontWeight: "500" }}>
                                            {address.addressLine1 ||
                                              address.address_line1}
                                          </span>
                                          {(address.addressLine2 ||
                                            address.address_line2) && (
                                              <span style={{ margin: "0 8px" }}>
                                                {address.addressLine2 ||
                                                  address.address_line2}
                                                ,
                                              </span>
                                            )}
                                          <span style={{ margin: "0 8px" }}>
                                            {address.area}, {address.city},
                                          </span>
                                          <span style={{ margin: "0 8px" }}>
                                            {address.state} - {address.pincode},
                                          </span>
                                          {/* <span style={{ color: "#666" }}>
                                            Ph: {address.phoneNumber}
                                          </span> */}
                                        </label>
                                      </div>
                                    )
                                  )
                                ) : (
                                  <p>
                                    No addresses found. Please add an address.
                                  </p>
                                )}
                              </div>

                              <Row>
                                <Col md={10}>
                                  <Button
                                    variant="primary"
                                    onClick={() => setShowAddressModal(true)}
                                    disabled={addressLoading}
                                    className="me-2"
                                    style={{ height: "60px" }}
                                  >
                                    {addressLoading
                                      ? "Adding..."
                                      : "Add New Address"}
                                  </Button>
                                </Col>
                              </Row>

                              {/* Courier Delivery Fields */}
                              <div className="mt-3">
                                <Col md={6}>
                                  {/* <div className="mb-3">
                                    <label className="form-label">
                                      Delivery Status
                                    </label>
                                    <select
                                      className="form-control"
                                      name="delivery_status"
                                      value={deliveryData.delivery_status}
                                      onChange={handleDeliveryDataChange}
                                    >
                                      <option value="PENDING">Pending</option>
                                      <option value="DISPATCHED">
                                        Dispatched
                                      </option>
                                      <option value="DELIVERED">
                                        Delivered
                                      </option>
                                    </select>
                                  </div> */}
                                  <div className="mb-3">
                                    <label className="form-label">Delivery Status</label>
                                    <Select
                                      value={statusOptions.find(
                                        (option) => option.value === deliveryData.delivery_status
                                      )}
                                      onChange={(selected) =>
                                        handleDeliveryDataChange({
                                          target: { name: "delivery_status", value: selected.value },
                                        })
                                      }
                                      options={statusOptions}
                                      isDisabled={disableActions}
                                      classNamePrefix="react-select"
                                      placeholder="Select status"
                                      styles={{
                                        control: (provided) => ({
                                          ...provided,
                                          minHeight: "38px",
                                          fontSize: "14px",
                                        }),
                                        singleValue: (provided) => ({
                                          ...provided,
                                          fontSize: "14px",
                                        }),
                                        option: (provided) => ({
                                          ...provided,
                                          fontSize: "14px",
                                        }),
                                        menu: (provided) => ({
                                          ...provided,
                                          zIndex: 9999,
                                        }),
                                      }}
                                    />
                                  </div>
                                </Col>

                                {/* Show fields based on status */}
                                {(deliveryData.delivery_status ===
                                  "DISPATCHED" ||
                                  deliveryData.delivery_status ===
                                  "DELIVERED") && (
                                    <Row className="mb-3">
                                      <Col md={6}>
                                        <label className="form-label">
                                          Delivery Partner
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="delivery_partner"
                                          value={deliveryData.delivery_partner}
                                          onChange={handleDeliveryDataChange}
                                          placeholder="Enter delivery partner"
                                          required
                                        />
                                      </Col>

                                      <Col md={6}>
                                        <label className="form-label">
                                          Delivery Code
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="delivery_code"
                                          value={deliveryData.delivery_code}
                                          onChange={handleDeliveryDataChange}
                                          placeholder="Enter delivery code"
                                          required
                                        />
                                      </Col>
                                    </Row>
                                  )}

                                {deliveryData.delivery_status ===
                                  "DELIVERED" && (
                                    <Row className="mb-3">
                                      <Col md={6}>
                                        <label className="form-label">
                                          Delivery Date
                                        </label>
                                        <input
                                          type="date"
                                          className="form-control"
                                          name="delivery_date"
                                          value={deliveryData.delivery_date}
                                          onChange={handleDeliveryDataChange}
                                          // max={new Date().toISOString().split("T")[0]}
                                          required
                                        />
                                      </Col>
                                    </Row>
                                  )}
                              </div>
                            </div>
                          )}
                        </Col>
                        <Row className="mb-3 ml-auto">
                          <Col
                            md={6}
                            className="d-flex align-items-end text-end"
                          >
                            {formData.deliveryOption === "By Courier" && (
                              <Button
                                variant="info"
                                onClick={handleCourierDone}
                                disabled={updateLoading || disableActions}
                              >
                                {updateLoading ? (
                                  <>
                                    <Loader size="sm" className="me-2" />
                                    Processing...
                                  </>
                                ) : (
                                  "Update Delivery Status"
                                )}
                              </Button>
                            )}
                          </Col>
                        </Row>
                      </Row>
                    </Row>

                    {/* Address Modal for Editing Address */}
                    <Modal
                      show={showAddressModal}
                      onHide={() => setShowAddressModal(false)}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Add New Address</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <form>
                          <div className="mb-3">
                            <label htmlFor="phoneNumber" className="form-label">
                              Phone Number<span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="phoneNumber"
                              name="phoneNumber"
                              value={addressData.phoneNumber}
                              onChange={handleAddressChange}
                              required
                            />
                          </div>
                          <div className="mb-3">
                            <label
                              htmlFor="addressLine1"
                              className="form-label"
                            >
                              Address Line 1
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="addressLine1"
                              name="addressLine1"
                              value={addressData.addressLine1}
                              onChange={handleAddressChange}
                              required
                            />
                          </div>
                          <div className="mb-3">
                            <label
                              htmlFor="addressLine2"
                              className="form-label"
                            >
                              Address Line 2
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="addressLine2"
                              name="addressLine2"
                              value={addressData.addressLine2}
                              onChange={handleAddressChange}
                            />
                          </div>
                          <div className="mb-3">
                            <label htmlFor="area" className="form-label">
                              Area<span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="area"
                              name="area"
                              value={addressData.area}
                              onChange={handleAddressChange}
                              required
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">
                              Country<span className="text-danger">*</span>
                            </label>
                            <Select
                              name="country"
                              options={countries}
                              value={
                                countries.find(
                                  (c) => c.value === addressData.country
                                ) || null
                              }
                              onChange={(selectedOption) => {
                                setAddressData((prev) => ({
                                  ...prev,
                                  country: selectedOption?.value || "",
                                  state: "",
                                  city: "",
                                }));
                              }}
                              placeholder="Select a Country"
                              styles={{
                                control: (provided) => ({
                                  ...provided,
                                  minHeight: "50px",
                                  height: "50px",
                                }),
                              }}
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">
                              State<span className="text-danger">*</span>
                            </label>
                            <Select
                              name="state"
                              options={states}
                              value={
                                states.find(
                                  (s) => s.value === addressData.state
                                ) || null
                              }
                              onChange={(selectedOption) => {
                                setAddressData((prev) => ({
                                  ...prev,
                                  state: selectedOption?.value || "",
                                  city: "",
                                }));
                              }}
                              placeholder="Select a State"
                              isDisabled={!addressData.country}
                              styles={{
                                control: (provided) => ({
                                  ...provided,
                                  minHeight: "50px",
                                  height: "50px",
                                }),
                              }}
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">
                              City<span className="text-danger">*</span>
                            </label>
                            <Select
                              name="city"
                              options={cities}
                              value={
                                cities.find(
                                  (c) => c.value === addressData.city
                                ) || null
                              }
                              onChange={(selectedOption) => {
                                setAddressData((prev) => ({
                                  ...prev,
                                  city: selectedOption?.value || "",
                                }));
                              }}
                              placeholder="Select a City"
                              isDisabled={!addressData.state}
                              styles={{
                                control: (provided) => ({
                                  ...provided,
                                  minHeight: "50px",
                                  height: "50px",
                                }),
                              }}
                            />
                          </div>
                          <div className="mb-3">
                            <label htmlFor="pincode" className="form-label">
                              Pincode<span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="pincode"
                              name="pincode"
                              value={addressData.pincode}
                              onChange={handleAddressChange}
                              pattern="[0-9]{6}"
                              maxLength="6"
                              required
                            />
                          </div>
                        </form>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="danger"
                          onClick={() => setShowAddressModal(false)}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="primary"
                          onClick={handleAddNewAddress}
                          disabled={
                            !addressData.addressLine1 ||
                            !addressData.city ||
                            !addressData.state ||
                            !addressData.country ||
                            !addressData.pincode ||
                            !addressData.phoneNumber
                          }
                        >
                          {addressLoading ? (
                            <>
                              <Loader size="sm" className="me-2" />
                              Adding...
                            </>
                          ) : (
                            "Save Address"
                          )}
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </div>

                  {/* Past Deliveries Section */}
                  {selectedPrescription?.delivery_details &&
                    selectedPrescription.delivery_details.length > 0 && (
                      <div className="mt-4">
                        <div className="card shadow-sm border-0">
                          <div className="card-header bg-white d-flex justify-content-between align-items-center py-3">
                            <h5 className="mb-0 text-primary">
                              <i className="fa fa-history me-2"></i>
                              Delivery Status
                            </h5>
                          </div>
                          <div className="card-body p-0">
                            <div className="table-responsive"
                              style={{
                                overflowX: "auto",
                                WebkitOverflowScrolling: "touch",
                              }}>
                              <table
                                className="table table-hover mb-0"
                                style={{
                                  borderSpacing: 0,
                                  minHeight: "70px",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <thead
                                  style={{
                                    backgroundColor: "#f8f9fa",
                                    height: "30px",
                                  }}
                                >
                                  <tr
                                    className="table-info"
                                    style={{
                                      backgroundColor: "#f8f9fa",
                                      height: "30px",
                                      padding: "0px",
                                    }}
                                  >
                                    <th
                                      style={{
                                        width: "50px",
                                        textAlign: "center",
                                        color: "black",
                                        fontWeight: "600",
                                        padding: "4px 8px",
                                      }}
                                    >
                                      <i
                                        className="fa fa-list"
                                        style={{ fontSize: "12px" }}
                                      ></i>
                                    </th>
                                    <th
                                      style={{
                                        color: "black",
                                        fontWeight: "600",
                                        padding: "4px 8px",
                                      }}
                                    >
                                      Date
                                    </th>
                                    <th
                                      style={{
                                        color: "black",
                                        fontWeight: "600",
                                        padding: "4px 8px",
                                      }}
                                    >
                                      Partner
                                    </th>
                                    <th
                                      style={{
                                        color: "black",
                                        fontWeight: "600",
                                        padding: "4px 8px",
                                      }}
                                    >
                                      Code
                                    </th>
                                    <th
                                      style={{
                                        color: "black",
                                        fontWeight: "600",
                                        padding: "4px 8px",
                                      }}
                                    >
                                      Status
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {[...selectedPrescription.delivery_details]
                                    .sort(
                                      (a, b) =>
                                        new Date(b.delivery_date) -
                                        new Date(a.delivery_date)
                                    )
                                    .map((delivery, index) => (
                                      <React.Fragment key={index}>
                                        <tr
                                          style={{
                                            cursor: "pointer",
                                            backgroundColor: "white",
                                            borderLeft: "4px solid transparent",
                                            transition: "all 0.3s ease",
                                            borderBottom: "1px solid #dee2e6",
                                            margin: 0,
                                            padding: 0,
                                            height: "35px",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#f8f9fa";
                                            e.currentTarget.style.borderLeftColor =
                                              "#0d6efd";
                                          }}
                                          onMouseLeave={(e) => {
                                            const elem =
                                              document.getElementById(
                                                `medicines${index}`
                                              );
                                            if (
                                              !elem?.classList.contains("show")
                                            ) {
                                              e.currentTarget.style.backgroundColor =
                                                "white";
                                              e.currentTarget.style.borderLeftColor =
                                                "transparent";
                                            }
                                          }}
                                          onClick={(e) => {
                                            const elem =
                                              document.getElementById(
                                                `medicines${index}`
                                              );
                                            const chevron =
                                              document.getElementById(
                                                `chevron${index}`
                                              );
                                            if (elem) {
                                              elem.classList.toggle("show");
                                              if (chevron) {
                                                chevron.style.transform =
                                                  elem.classList.contains(
                                                    "show"
                                                  )
                                                    ? "rotate(90deg)"
                                                    : "rotate(0deg)";
                                              }
                                              e.currentTarget.style.backgroundColor =
                                                elem.classList.contains("show")
                                                  ? "#f8f9fa"
                                                  : "white";
                                              e.currentTarget.style.borderLeftColor =
                                                elem.classList.contains("show")
                                                  ? "#0d6efd"
                                                  : "transparent";
                                            }
                                          }}
                                        >
                                          <td
                                            className="text-center"
                                            style={{
                                              padding: "4px 8px",
                                            }}
                                          >
                                            <div
                                              style={{
                                                width: "24px",
                                                height: "24px",
                                                borderRadius: "50%",
                                                backgroundColor: "#e3f2fd",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                margin: "0 auto",
                                              }}
                                            >
                                              <i
                                                id={`chevron${index}`}
                                                className="fa fa-chevron-right text-primary"
                                                style={{
                                                  transition:
                                                    "transform 0.3s ease",
                                                  fontSize: "10px",
                                                }}
                                              ></i>
                                            </div>
                                          </td>
                                          {/* <td
                                            style={{
                                              fontWeight: "500",
                                              padding: "4px 8px",
                                            }}
                                          >
                                            {formatDate(
                                              delivery.delivery_date
                                            ).toLocaleDateString("en-US", {
                                              year: "numeric",
                                              month: "short",
                                              day: "numeric",
                                            })}
                                          </td> */}
                                          <td
                                            style={{
                                              fontWeight: "500",
                                              padding: "4px 8px",
                                            }}
                                          >
                                            {delivery.delivery_date
                                              ? new Date(delivery.delivery_date)
                                                .toLocaleDateString("en-GB", {
                                                  day: "2-digit",
                                                  month: "2-digit",
                                                  year: "numeric",
                                                })
                                                .replace(/\//g, "-") // ensure dd-mm-yyyy format
                                              : "-"}
                                          </td>

                                          <td style={{ padding: "4px 8px" }}>
                                            {/* <span className="text-muted">
                                              {delivery.delivery_partner ||
                                                "BY HAND"}
                                            </span> */}
                                            <span className="text-muted">
                                              {delivery.delivery_option === "BY_COURIER"
                                                ? delivery.delivery_partner || "BY COURIER"
                                                : "BY HAND"}
                                            </span>

                                          </td>
                                          <td style={{ padding: "4px 8px" }}>
                                            {/* <code className="bg-light px-2 py-1 rounded"> */}
                                            {delivery.delivery_code || "N/A"}
                                            {/* </code> */}
                                          </td>
                                          <td style={{ padding: "4px 8px" }}>
                                            <div
                                              className="dropdown"
                                              style={{ position: "relative" }}
                                            >
                                              <button
                                                className={`btn ${delivery.delivery_status ===
                                                  "DELIVERED"
                                                  ? "btn-success"
                                                  : delivery.delivery_status ===
                                                    "DISPATCHED"
                                                    ? "btn-info"
                                                    : "btn-warning"
                                                  }  d-flex align-items-center justify-content-center`}
                                                type="button"
                                                style={{
                                                  fontSize: "11px",
                                                  padding: "4px 8px",
                                                  minWidth: "100px",
                                                  textAlign: "center",
                                                  cursor:
                                                    delivery.delivery_status ===
                                                      "DELIVERED"
                                                      ? "not-allowed"
                                                      : "pointer",
                                                  opacity:
                                                    delivery.delivery_status ===
                                                      "DELIVERED"
                                                      ? 0.8
                                                      : 1,
                                                }}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  if (
                                                    delivery.delivery_status !==
                                                    "DELIVERED"
                                                  ) {
                                                    setOpenDropdownIndex(
                                                      openDropdownIndex ===
                                                        index
                                                        ? null
                                                        : index
                                                    );
                                                  }
                                                }}
                                                disabled={delivery.delivery_status === "DELIVERED" || disableActions}
                                              >
                                                <span>
                                                  {delivery.delivery_status}
                                                </span>
                                                {delivery.delivery_status !==
                                                  "DELIVERED" && (
                                                    <i
                                                      className={`fa fa-chevron-${openDropdownIndex ===
                                                        index
                                                        ? "up"
                                                        : "down"
                                                        } ms-2`}
                                                      style={{ fontSize: "10px" }}
                                                    ></i>
                                                  )}
                                              </button>
                                              {openDropdownIndex === index &&
                                                delivery.delivery_status !==
                                                "DELIVERED" && (
                                                  <ul
                                                    className="dropdown-menu show"
                                                    style={{
                                                      position: "absolute",
                                                      top: "100%",
                                                      left: "0",
                                                      minWidth: "120px",
                                                      zIndex: 1000,
                                                      marginTop: "4px",
                                                      boxShadow:
                                                        "0 2px 5px rgba(0,0,0,0.1)",
                                                      border:
                                                        "1px solid rgba(0,0,0,0.1)",
                                                      borderRadius: "4px",
                                                      backgroundColor: "white",
                                                    }}
                                                  >
                                                    {delivery.delivery_status ===
                                                      "PENDING" && (
                                                        <>
                                                          <li>
                                                            <button
                                                              className={`dropdown-item ${delivery.delivery_status ===
                                                                "DISPATCHED"
                                                                ? "active"
                                                                : ""
                                                                }`}
                                                              onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleStatusSelect(
                                                                  delivery,
                                                                  "DISPATCHED"
                                                                );
                                                                setOpenDropdownIndex(
                                                                  null
                                                                );
                                                              }}
                                                              style={{
                                                                fontSize: "13px",
                                                                padding:
                                                                  "8px 12px",
                                                              }}
                                                            >
                                                              Dispatched
                                                            </button>
                                                          </li>
                                                          <li>
                                                            <button
                                                              className={`dropdown-item ${delivery.delivery_status ===
                                                                "DELIVERED"
                                                                ? "active"
                                                                : ""
                                                                }`}
                                                              onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleStatusSelect(
                                                                  delivery,
                                                                  "DELIVERED"
                                                                );
                                                                setOpenDropdownIndex(
                                                                  null
                                                                );
                                                              }}
                                                              style={{
                                                                fontSize: "13px",
                                                                padding:
                                                                  "8px 12px",
                                                              }}
                                                            >
                                                              Delivered
                                                            </button>
                                                          </li>
                                                        </>
                                                      )}
                                                    {delivery.delivery_status ===
                                                      "DISPATCHED" && (
                                                        <li>
                                                          <button
                                                            className={`dropdown-item ${delivery.delivery_status ===
                                                              "DELIVERED"
                                                              ? "active"
                                                              : ""
                                                              }`}
                                                            onClick={(e) => {
                                                              e.stopPropagation();
                                                              handleStatusSelect(
                                                                delivery,
                                                                "DELIVERED"
                                                              );
                                                              setOpenDropdownIndex(
                                                                null
                                                              );
                                                            }}
                                                            style={{
                                                              fontSize: "13px",
                                                              padding: "8px 12px",
                                                            }}
                                                          >
                                                            Delivered
                                                          </button>
                                                        </li>
                                                      )}
                                                  </ul>
                                                )}
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            colSpan="5"
                                            className="p-0"
                                            style={{ border: "none" }}
                                          >
                                            <div
                                              className="collapse"
                                              id={`medicines${index}`}
                                              style={{
                                                backgroundColor: "#f8f9fa",
                                                transition: "all 0.3s ease",
                                                margin: 0,
                                                padding: 0,
                                              }}
                                            >
                                              <div
                                                className={`px-4 ${openDropdownIndex === index
                                                  ? "py-4"
                                                  : "py-0"
                                                  }`}
                                              >
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                  <h6 className="mb-0 text-primary">
                                                    <i className="fa fa-pills me-2"></i>
                                                    Delivered Medicines
                                                  </h6>
                                                  <span className="badge bg-light text-dark">
                                                    {delivery.delivery_medicines
                                                      ?.length || 0}{" "}
                                                    Items
                                                  </span>
                                                </div>

                                                {delivery.delivery_medicines &&
                                                  delivery.delivery_medicines
                                                    .length > 0 ? (
                                                  <div className="table-responsive">
                                                    <table className="table table-sm table-bordered bg-white mb-0 rounded overflow-hidden">
                                                      <thead className="bg-primary text-white">
                                                        <tr>
                                                          <th
                                                            style={{
                                                              fontSize: "12px",
                                                            }}
                                                          >
                                                            Medicine Name
                                                          </th>
                                                          <th
                                                            style={{
                                                              fontSize: "12px",
                                                            }}
                                                          >
                                                            Quantity Delivered
                                                          </th>
                                                          <th
                                                            style={{
                                                              fontSize: "12px",
                                                            }}
                                                          >
                                                            Instructions
                                                          </th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        {delivery.delivery_medicines.map(
                                                          (
                                                            medicine,
                                                            medIndex
                                                          ) => (
                                                            <tr key={medIndex}>
                                                              <td
                                                                style={{
                                                                  fontSize:
                                                                    "13px",
                                                                  fontWeight:
                                                                    "500",
                                                                }}
                                                              >
                                                                <i className="fa fa-pill me-2 text-muted"></i>
                                                                {medicine.medicine_name ||
                                                                  medicine.name}
                                                              </td>
                                                              <td
                                                                style={{
                                                                  fontSize:
                                                                    "13px",
                                                                }}
                                                              >
                                                                <span className="badge bg-light text-primary">
                                                                  {medicine.updated_qty ||
                                                                    medicine.quantity ||
                                                                    "N/A"}
                                                                </span>
                                                              </td>
                                                              <td
                                                                style={{
                                                                  fontSize:
                                                                    "12px",
                                                                  color: "#666",
                                                                }}
                                                              >
                                                                {medicine.instructions ||
                                                                  medicine.how_to_take ||
                                                                  "No specific instructions"}
                                                              </td>
                                                            </tr>
                                                          )
                                                        )}
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                ) : (
                                                  <div className="text-center py-4">
                                                    <div className="mb-3">
                                                      <i
                                                        className="fa fa-exclamation-triangle text-warning"
                                                        style={{
                                                          fontSize: "48px",
                                                        }}
                                                      ></i>
                                                    </div>
                                                    <h6 className="text-muted">
                                                      No Medicine Records
                                                    </h6>
                                                    <p
                                                      className="text-muted mb-0"
                                                      style={{
                                                        fontSize: "14px",
                                                      }}
                                                    >
                                                      No medicines were recorded
                                                      for this delivery.
                                                    </p>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          </td>
                                        </tr>
                                      </React.Fragment>
                                    ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                  {/* Error Display */}
                  {(error || updateError || addressError) && (
                    <Alert variant="danger" className="mt-3">
                      {error || updateError || addressError}
                    </Alert>
                  )}
                </div>
              </div>
            ) : (
              <div className="card border-0 shadow-sm">
                <div className="card-body">
                  <div className="text-center py-5">
                    <div
                      className="alert alert-info"
                      role="alert"
                      style={{
                        maxWidth: "600px",
                        margin: "0 auto",
                        borderRadius: "10px",
                        padding: "30px",
                      }}
                    >
                      <div style={{ marginBottom: "25px" }}>
                        <i
                          className="fa fa-clipboard-list fa-4x"
                          style={{ color: "#17a2b8" }}
                        ></i>
                      </div>
                      <h4 className="alert-heading mb-4">
                        No Prescription Selected
                      </h4>
                      <div
                        style={{
                          backgroundColor: "#f8f9fa",
                          padding: "20px",
                          borderRadius: "8px",
                          marginBottom: "15px",
                        }}
                      >
                        <p
                          className="mb-3"
                          style={{ fontSize: "16px", color: "#495057" }}
                        >
                          Please select a patient from the list to view their
                          prescription details.
                        </p>
                        <p
                          className="mb-0"
                          style={{ fontSize: "14px", color: "#6c757d" }}
                        >
                          Prescription information will appear here once a
                          patient is selected.
                        </p>
                      </div>
                      <div
                        style={{
                          marginTop: "20px",
                          fontSize: "14px",
                          color: "#6c757d",
                        }}
                      >
                        <i className="fa fa-info-circle me-2"></i>
                        Select a patient to get started.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <StatusUpdateModal />
        </div>
      </div>
    </>
  );
};

export default Medical;